if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.addEventListener('change', (event)=> {this.updateLabelCor(event)})
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });
      this.productWrapper = this.closest('.thb-product-detail');
      if (this.productWrapper) {
        this.productSlider = this.productWrapper.querySelector(`#MediaGallery-${this.dataset.section}`);
        if (!this.productSlider) {
          this.productSlider = this.productWrapper.querySelector('.product-carousel-with-thumbnails, .product-gallery-swiper-wrapper');
        }
        this.hideVariants = this.productSlider ? this.productSlider.dataset.hideVariants === 'true' : false;
      }
      
      const isInfluencersSection = this.closest('#featured-product-influencers-section') !== null;
      if (isInfluencersSection) {
        this.addEventListener('click', (e) => {
          const clickedFieldset = e.target.closest('fieldset');
          if (e.target.type === 'radio' && this.isColorFieldsetElement(clickedFieldset)) {
            const sizeFieldset = this.fieldsets?.[0];
            if (sizeFieldset) {
              const checkedSizeInputs = Array.from(sizeFieldset.querySelectorAll('input:checked'));
            }
          }
        }, true);
      }
    }

    connectedCallback() {
      // Set original index on color options before any reordering
      this.setOriginalColorIndexes();
      
      if (this.updateUrl) {
        this.updateOptions();
        this.updateMasterId();
        this.setDisabled();
        this.setImageSet();
        this.updatePreOrder();
        this.updateThumbnailsForVariant();
      } else {
        // Even if updateUrl is false, we still need to set disabled options
        // This is important for featured-product and other sections
        this.updateOptions();
        this.setDisabled();
      }
      
      document.addEventListener('swiper:cache-ready', () => {
        this.updateThumbnailsForVariant();
      }, { once: true });

    }

    isColorFieldsetElement(fieldset) {
      if (!fieldset) return false;
      const handle = (fieldset.dataset.handle || '').toLowerCase();
      return fieldset.classList.contains('fieldset--color') ||
        handle === 'color' ||
        handle === 'colour' ||
        handle.includes('color') ||
        handle.includes('colour') ||
        fieldset.dataset.isGrouped === 'true';
    }

    getColorFieldset() {
      const directMatch = this.querySelector('.fieldset--color, [data-handle="color"], [data-handle="colour"]');
      if (directMatch) return directMatch;

      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      const semanticMatch = fieldsets.find((fs) => this.isColorFieldsetElement(fs));
      if (semanticMatch) return semanticMatch;

      // Legacy fallback: color usually sits on option2.
      return fieldsets.find((fs) => fs.dataset.index === 'option2');
    }

    setOriginalColorIndexes() {
      // Find the color fieldset
      const colorFieldset = this.getColorFieldset();
      
      if (!colorFieldset) return;
      
      const isGrouped = colorFieldset.dataset.isGrouped === 'true';
      
      if (colorFieldset.querySelector('select')) {
        // Handle select dropdown
        const select = colorFieldset.querySelector('select');
        const options = Array.from(select.querySelectorAll('option'));
        options.forEach((option, index) => {
          if (option.value && !option.dataset.originalIndex) {
            option.dataset.originalIndex = index;
          }
        });
      } else if (colorFieldset.querySelectorAll('input').length) {
        // Handle radio inputs
        if (isGrouped) {
          // For grouped colors, set index within each group
          const allHrs = Array.from(colorFieldset.querySelectorAll('hr'));
          
          allHrs.forEach((hr, hrIndex) => {
            const previousHr = hrIndex > 0 ? allHrs[hrIndex - 1] : null;
            const startElement = previousHr ? previousHr.nextElementSibling : colorFieldset.firstElementChild;
            let groupIndex = 0;
            let currentElement = startElement;
            
            // First pass: collect all elements in order
            const groupElements = [];
            while (currentElement && currentElement !== hr) {
              if (currentElement.tagName === 'DIV' && 
                  currentElement.querySelector('input[type="radio"]') &&
                  currentElement.getAttribute('style') && 
                  currentElement.getAttribute('style').includes('position: relative')) {
                const input = currentElement.querySelector('input[type="radio"]');
                if (input && input.value) {
                  groupElements.push(currentElement);
                }
              }
              currentElement = currentElement.nextElementSibling;
            }
            
            // Second pass: set original indexes
            groupElements.forEach((element, index) => {
              if (!element.dataset.originalIndex) {
                element.dataset.originalIndex = index;
              }
            });
          });
        } else {
          // For non-grouped colors, use data-original-order from Liquid template
          // If not present, fallback to current index
          const container = colorFieldset.querySelector('.form__label__options') || colorFieldset;
          const inputs = Array.from(container.querySelectorAll('input[type="radio"]'));
          inputs.forEach((input, index) => {
            if (input.value) {
              const wrapper = input.closest('.variant-input-label') || input.parentElement;
              if (wrapper) {
                // Use data-original-order from Liquid if available, otherwise use current index
                if (!wrapper.dataset.originalIndex) {
                  wrapper.dataset.originalIndex = wrapper.dataset.originalOrder || index;
                }
              }
            }
          });
        }
      }
    }

    onVariantChange(event) {
      // Detectar mudança de Collection
      const targetFieldset = event?.target?.closest('fieldset');
      const changedFieldsetIndex = targetFieldset ? this.fieldsets.indexOf(targetFieldset) : -1;
      const isCollectionChange = targetFieldset && (
        targetFieldset.dataset.handle?.toLowerCase().includes('collection') ||
        targetFieldset.querySelector('.form__label')?.textContent?.toLowerCase().includes('collection')
      );

      // Check if this is an intentional deselection (from featured-product toggle)
      const isDeselection = event.isDeselection || this.dataset.skipAutoSelect === 'true';

      this.updateOptions();
      
      // Only auto-select if this is not an intentional deselection
      if (!isDeselection) {
        const autoSelected = this.ensureDefaultSelections(event);
        if (autoSelected) {
          this.updateOptions();
        }
      }
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();
      
      // Auto-select next option if a fieldset changed and we're not deselecting
      if (!isDeselection && changedFieldsetIndex >= 0 && changedFieldsetIndex < this.fieldsets.length - 1) {
        setTimeout(() => {
          this.autoSelectFirstValidOption(changedFieldsetIndex + 1);
          this.updateOptions();
          this.updateMasterId();
          this.setDisabled();
          if (this.currentVariant) {
            this.updateVariantText();
            this.updateMedia();
            this.updateThumbnailsForVariant();
            this.updateURL();
            this.updateVariantInput();
            removePreOrderMessage();
            this.updatePreOrder();
            const isMainProductNew = document.querySelector('.content-main-product');
            if (isMainProductNew || !window.location.pathname.startsWith("/pages/") || window.location.pathname.includes("lp-pet-bed")) {
              this.renderProductInfo();
            } else {
              this.renderProductInfoPages();
            }
            this.toggleAddButton(!this.currentVariant?.available, window.theme.variantStrings.soldOut);
          }
        }, 50);
      }
      
      // Update label colors/material info
      if (typeof this.updateLabelCor === 'function') {
        this.updateLabelCor(event);
      }
      this.updateReadyToShipAttribute();
      // Remove pre-order message when variant changes
      removePreOrderMessage();
      this.updatePreOrder();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        this.updateThumbnailsForVariant();
        this.updateURL();
        this.updateVariantInput();
        if (!window.location.pathname.startsWith("/pages/")) {
          this.renderProductInfo();
        } else {
          this.renderProductInfoPages();
        }
        //this.updateShareUrl();
      }
      this.updateOther();
      this.updateScarcityWarning();
      this.updateRarelyAvailableBadge();
      this.updateVariantCustomBadges();
      
      // Auto-selecionar primeiro Pack Option quando Collection muda
      if (isCollectionChange) {
        setTimeout(() => {
          this.autoSelectFirstPackOption();
          this.updateOptions();
          this.updateMasterId();
          if (this.currentVariant) {
            this.updateVariantText();
            this.updateMedia();
            this.updateThumbnailsForVariant();
            this.updateURL();
            this.updateVariantInput();
            removePreOrderMessage();
            this.updatePreOrder();
            const isMainProductNew = document.querySelector('.content-main-product');
            if (isMainProductNew || !window.location.pathname.startsWith("/pages/") || window.location.pathname.includes("lp-pet-bed")) {
              this.renderProductInfo();
            } else {
              this.renderProductInfoPages();
            }
            this.toggleAddButton(!this.currentVariant?.available, window.theme.variantStrings.soldOut);
          }
        }, 50);
      }
      
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });

      // Reconnect thumbnails sync after variant update
      const productSlider = this.productSlider?.querySelector('product-slider');
      if (productSlider) {
        const sectionId = this.dataset.section;
        const thumbnails = document.querySelector(`#Product-Thumbnails-${sectionId}`);
        if (thumbnails) {
          // Use the new refresh method
          productSlider.refreshThumbnailSync();
        }
      }
    }

    ensureDefaultSelections(event) {
      const targetFieldset = event?.target?.closest('fieldset');
      if (!targetFieldset || !(targetFieldset.dataset.handle === 'bed-size' || targetFieldset.classList.contains('fieldset--bed-size') || targetFieldset.dataset.index === 'option1')) {
        return false;
      }

      const colorFieldset = this.getColorFieldset();
      if (!colorFieldset || colorFieldset.querySelector('input:checked, select[value]')) {
        return false;
      }

      const selectEl = colorFieldset.querySelector('select');
      if (selectEl && !selectEl.value) {
        const firstValid = Array.from(selectEl.options).find(opt => opt.value && !opt.disabled && opt.style.display !== 'none');
        if (firstValid) { selectEl.value = firstValid.value; return true; }
      }

      // Allow selection of sold out colors (is-disabled is now only for styling)
      const firstValidInput = Array.from(colorFieldset.querySelectorAll('input')).find(inp => !inp.disabled && inp.style.display !== 'none' && inp.style.pointerEvents !== 'none');
      if (firstValidInput) {
        firstValidInput.checked = true;
        try { this.updateLabelCor({ target: firstValidInput }); } catch (e) { }
        return true;
      }
      return false;
    }

    updateReadyToShipAttribute() {
      this.productGridContainer = this.productWrapper.querySelector('.product-grid-container');
      if (!this.productGridContainer) return;

      this.variantSpan = this.productWrapper.querySelector(`variant-selects .variations span[data-variant-id="${this.currentVariant.id}"]`);

      if (this.variantSpan) {
        this.inventoryQuantity = parseInt(this.variantSpan.getAttribute('data-variant-quantity')) || 0;
        this.productGridContainer.setAttribute('data-product-ready-to-ship', this.inventoryQuantity > 0 ? 'true' : 'false');
      }
    }

    listenClicksDisabledVariant() {
      this.addEventListener('click', (event) => {
        const target = event.target;

        // Check if clicked element is a disabled input or its label
        let disabledInput = null;

        if (target.tagName === 'INPUT' && target.classList.contains('is-disabled')) {
          disabledInput = target;
        } else if (target.tagName === 'LABEL') {
          const input = target.previousElementSibling || target.nextElementSibling;
          if (input && input.tagName === 'INPUT' && input.classList.contains('is-disabled')) {
            disabledInput = input;
          }
        } else if (target.closest('label')) {
          const label = target.closest('label');
          const input = label.previousElementSibling || label.nextElementSibling;
          if (input && input.tagName === 'INPUT' && input.classList.contains('is-disabled')) {
            disabledInput = input;
          }
        }

        if (disabledInput) {
          removePreOrderMessage();
        }
      });
    }

    updateLabelCor(event) {
      if(!window.variantsColors) return;
      
      // Ensure options are up to date before processing
      this.updateOptions();
      
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));

      fieldsets.forEach((item, i) => {
        const label = item.querySelector('.form__label__text');
        const valueSpan = item.querySelector('.form__label__value');
        const selectedValue = this.options[i];

        // If no value is selected, clear everything immediately
        if (!selectedValue || selectedValue === '' || selectedValue === null || selectedValue === undefined) {
          if (item.dataset.isGrouped === 'true') {
            const groupTexts = item.querySelectorAll('.form__label__text');
            groupTexts.forEach(el => { el.innerHTML = ''; });
          } else if (label) {
            label.innerHTML = '';
          }
          const valueSpan = item.querySelector('.form__label__value');
          if (valueSpan) { valueSpan.innerHTML = ''; }
          return;
        }

        const variantColor = window.variantsColors.find(variant => {
          return Array.isArray(variant.metaobject_colors?.values) &&
            variant.metaobject_colors.values.some(color => color.label === selectedValue);
        });
        
        const hasGroupColors = item.dataset.isGrouped === 'true';

        if(hasGroupColors){
          const fixedLabel = item.querySelector('.form__label__text--grouped-material') || item.querySelector('.form__label__container .form__label__text');

          if (!fixedLabel) {
            return;
          }

          if (!variantColor) {
            fixedLabel.innerHTML = `<span class="form__label__grouped-color-line"><strong>Colors:</strong> ${selectedValue}</span>`;
            return;
          }

          const hasMaterial = variantColor.title_material && variantColor.title_material.trim() !== '';
          const hasSeparator = variantColor.separator && variantColor.separator.trim() !== '';
          const hasColorTitle = variantColor.title_color && variantColor.title_color.trim() !== '';
          const colorTitle = hasColorTitle ? variantColor.title_color.trim() : 'Colors:';

          let html = '';
          if (hasMaterial) {
            html = `<span class="form__label__grouped-material-line"><strong>${variantColor.title_material}</strong> ${variantColor.content_material}`;
            if (hasSeparator) {
              html += ` <span class="form__label__separator">${variantColor.separator}</span>`;
            }
            html += `</span>`;
          }
          html += `<span class="form__label__grouped-color-line"><strong>${colorTitle}</strong> ${selectedValue}</span>`;
          fixedLabel.innerHTML = html;
          return;
        }

        if (!label) {
          return;
        }

        if (variantColor && !hasGroupColors) {
          // Only show label if we have both material and color info
          if (variantColor.title_color && variantColor.title_color.trim() !== '') {
            const html = `<div><strong>${variantColor.title_material}</strong> ${variantColor.content_material}</div> <span class="form__label__separator">${variantColor.separator}</span> <div><strong>${variantColor.title_color.trim()}</strong> <span class="form__label__value">${this.options[i]}</span></div>`;
            label.innerHTML = html;
            if (valueSpan) {
              valueSpan.textContent = this.options[i];
              valueSpan.style.display = '';
            }
          } else {
            // If no color info but we have variantColor, just show option name and value in label
            const optionName = item.querySelector('select, input')?.dataset.optionName || 'Color';
            label.innerHTML = `<strong>${optionName}:</strong> ${selectedValue}`;
            if (valueSpan) {
              valueSpan.textContent = '';
              valueSpan.style.display = 'none';
            }
          }
        } else {
          // If no variantColor found, show the default option name and value in label
          const optionName = item.querySelector('select, input')?.dataset.optionName || 'Color';
          label.innerHTML = `<strong>${optionName}:</strong> ${selectedValue}`;
          if (valueSpan) {
            valueSpan.textContent = '';
            valueSpan.style.display = 'none';
          }
        }
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.option_keys = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
          this.option_keys.push(fieldset.querySelector('select').name);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked')?.value);
          this.option_keys.push(fieldset.querySelector('input').name);
        }
      });
      this.dataset.options = this.options;
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');

        let labelDimension = item.querySelector('.form__label__value-dimension');
        const size_dimension = item.dataset.sizeDimension ? JSON.parse(item.dataset.sizeDimension) : null;

        if (label) {
          // Clear label if no option is selected
          label.innerHTML = this.options[i] || '';
        }

        // Clear dimension label if no option is selected
        if (labelDimension) {
          if (size_dimension && this.options[i]) {
            const selected_option = String(this.options[i]).toLowerCase();
            
            const dimension_info = size_dimension.find(dimension => {
              return String(dimension.size).toLowerCase() === selected_option;
            })
            if (dimension_info) {
              labelDimension.innerHTML = dimension_info.dimension;
            } else {
              labelDimension.innerHTML = '';
            }
          } else {
            labelDimension.innerHTML = '';
          }
        }
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
      this.productId = window.theme.settings.product_id;
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value="${option}"]`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }
    //here 2
    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
      if (!this.productSlider) return;
      let mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
      let activeMedia = this.productSlider.querySelector(`[data-media-id="${mediaId}"]`);


      this.productSlider.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });

      this.setImageSetMedia();

      if (!activeMedia) return;

      activeMedia.classList.add('is-active');

      activeMedia.parentElement.prepend(activeMedia);

      if (!this.sticky) {
        window.setTimeout(() => {
          if (window.innerWidth > 1068) {
            let header_h = activeMedia.parentElement.offsetTop - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')),
              scroll_obj = {
                left: 0,
                behavior: 'instant'
              };

            if (header_h > 0) {
              scroll_obj.top = header_h;
            }
            window.scrollTo(scroll_obj);
          }
          activeMedia.parentElement.scrollTo({
            left: 0,
            behavior: 'instant'
          });
        });
      }

    }

    updateURL() {
      if (!this.currentVariant) return;
      const url = new URL(window.location);
      url.searchParams.set('variant', this.currentVariant.id);
      history.replaceState({}, '', url);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
      
      // Update quantity input constraints based on inventory policy
      this.updateQuantityConstraints();
    }

    updateQuantityConstraints() {
      if (!this.currentVariant) return;
      
      const quantityInput = document.querySelector(`#Quantity-${this.dataset.section}`);
      if (!quantityInput) return;
      
      // Check if current variant has inventory policy "continue"
      const variantSpan = document.querySelector(`span[data-variant-id="${this.currentVariant.id}"]`);
      if (variantSpan) {
        const inventoryPolicy = variantSpan.getAttribute('data-variant-preorder');
        const inventoryQuantity = parseInt(variantSpan.getAttribute('data-variant-quantity')) || 0;
        
        // Update quantity input attributes
        quantityInput.setAttribute('data-variant-id', this.currentVariant.id);
        quantityInput.setAttribute('data-inventory-policy', inventoryPolicy);
        quantityInput.setAttribute('data-inventory-quantity', inventoryQuantity);
        
        let maxQuantity = null;
        
        if (inventoryPolicy === 'continue') {
          // When inventory policy allows overselling, use quantity rule max if available
          if (this.currentVariant.quantity_rule && this.currentVariant.quantity_rule.max) {
            maxQuantity = this.currentVariant.quantity_rule.max;
          }
        } else {
          // When inventory policy is "deny", limit by available inventory
          if (inventoryQuantity > 0) {
            if (this.currentVariant.quantity_rule && this.currentVariant.quantity_rule.max) {
              maxQuantity = Math.min(this.currentVariant.quantity_rule.max, inventoryQuantity);
            } else {
              maxQuantity = inventoryQuantity;
            }
          }
        }
        
        if (maxQuantity !== null) {
          quantityInput.setAttribute('max', maxQuantity);
        } else {
          quantityInput.removeAttribute('max');
        }
        
        // Update min and step based on current variant
        if (this.currentVariant.quantity_rule) {
          quantityInput.setAttribute('min', this.currentVariant.quantity_rule.min || 1);
          quantityInput.setAttribute('step', this.currentVariant.quantity_rule.increment || 1);
        }
        
        // Trigger validation update for the quantity selector
        const quantitySelector = quantityInput.closest('quantity-selector');
        if (quantitySelector) {
          quantitySelector.validateQtyRules();
        }
      }
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    // Update Scarcity Warning Variant
    updateScarcityWarning() {
      // Check if a variant is selected
      if (!this.currentVariant) {
        return;
      }

      // Find the <span> element with the data-variant-id attribute equal to the selected variant's ID
      const variantMetafieldElement = document.querySelector(
        `span[data-variant-id="${this.currentVariant.id}"]`
      );

      // Check if the element is found and extract the metafield value
      const scarcityMetafield = variantMetafieldElement
        ? variantMetafieldElement.getAttribute('data-scarcity-metafield')
        : null;

      // Find the container and the scarcity warning text
      const scarcityWarningContainer = document.getElementById('scarcity-warning-container');
      const scarcityWarningText = document.getElementById('scarcity-warning-text');

        // If the metafield has a value and is not empty
        if (scarcityWarningContainer && scarcityMetafield && scarcityMetafield !== "") {
            // Make the scarcity warning container visible
            scarcityWarningContainer.style.display = 'inline-block';

            // Update the scarcity warning text with the metafield value
            scarcityWarningText.innerHTML = scarcityMetafield;
        } else if (scarcityWarningContainer) {
            // Hide the container if there is no value to display
            scarcityWarningContainer.style.display = 'none';
        }
    }

    // Update Rarely Badge
    updateRarelyAvailableBadge() {
      // Check if a variant has been selected
      if (!this.currentVariant) {
        return;
      }

      // Find the <span> element corresponding to the selected variant using the data-variant-id attribute
      const variantMetafieldElement = document.querySelector(
        `span[data-variant-id="${this.currentVariant.id}"][data-rarely-available-metafield]`
      );

      // Check if the element was found and extract the metafield value
      const rarelyAvailableMetafield = variantMetafieldElement
        ? variantMetafieldElement.getAttribute('data-rarely-available-metafield')
        : null;

      // References to the container and the badge text
      const rarelyAvailableContainer = document.getElementById('rarely-available-container');
      const rarelyAvailableText = document.getElementById('rarely-available-text');

      // If the metafield has a value, show the badge
      if (rarelyAvailableMetafield && rarelyAvailableMetafield.trim() !== "") {

        // Update the text in the container
        rarelyAvailableText.textContent = rarelyAvailableMetafield;

        // Make the container visible
        rarelyAvailableContainer.style.display = 'inline-block';
      } else {
        // Hide the container if there is no value
        rarelyAvailableContainer.style.display = 'none';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
    }

    renderProductInfoPages() {
      const productHandle = JSON.parse(localStorage.getItem('selectedProductHandle'));

      if (!productHandle || !this.currentVariant) {
        return;
      }

      const isMainProductNew = document.querySelector(".content-main-product");
      if (isMainProductNew) {
        return;
      }

      fetch(`/products/${productHandle}?variant=${this.currentVariant.id}`)
        .then(response => response.text())
        .then(html => {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;

          const dataPreorder = tempDiv.querySelector('#variants-information-preorder');
          const jsonPreorder = dataPreorder ? JSON.parse(dataPreorder.textContent) : null;
          if (jsonPreorder) this.verifyPreorder(jsonPreorder);

          const newPriceOf = tempDiv.querySelector('.price_of');
          const newPriceFor = tempDiv.querySelector('.price_for');

          if (newPriceOf && newPriceFor) {
            document.querySelector('.price_of').innerHTML = newPriceOf.innerHTML;
            document.querySelector('.price_for').innerHTML = newPriceFor.innerHTML;
          }
        })
        .catch(error => {
          console.error('Erro ao buscar informações do produto:', error);
        });
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          // badges on sale
          const classBadgeOnSale = `#MediaGallery-${this.dataset.section} .vg-badge-right-on-sale`;
          const variantBadgesDestination = document.querySelector(classBadgeOnSale);
          const variantBadgesSource = html.querySelector(classBadgeOnSale);

          const getSavedAmount = variantBadgesSource?.querySelector('.badge.onsale')?.getAttribute('data-value');
          const valueSanitized = getSavedAmount ? parseFloat(getSavedAmount) : null;

          if (variantBadgesSource && variantBadgesDestination && valueSanitized > 0) {
            variantBadgesDestination.style.display = 'none';
            variantBadgesDestination.innerHTML = variantBadgesSource.innerHTML;
            variantBadgesDestination.style.display = 'flex';
          } else if (variantBadgesDestination && (valueSanitized === null || valueSanitized === 0)) {
            variantBadgesDestination.style.display = 'none';
          }
          // end badges on sale

          const dataPreorder = html.querySelector('#variants-information-preorder');
          const jsonPreorder = dataPreorder ? JSON.parse(dataPreorder.textContent) : null;
          if (jsonPreorder) this.verifyPreorder(jsonPreorder);

          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + '--sticky');

            if (price) price.classList.remove('visibility-hidden');
            if (price_fixed) price_fixed.classList.remove('visibility-hidden');

          });
          
          // Check if current variant has inventory policy "continue" (allow overselling)
          let hasInventoryPolicyContinue = false;
          if (this.currentVariant) {
            const variantSpan = document.querySelector(`span[data-variant-id="${this.currentVariant.id}"]`);
            if (variantSpan) {
              const inventoryPolicy = variantSpan.getAttribute('data-variant-preorder');
              hasInventoryPolicyContinue = inventoryPolicy === 'continue';
            }
          }
          
          // If inventory policy is "continue", don't disable the button even if not available
          const shouldDisable = hasInventoryPolicyContinue ? false : !this.currentVariant.available;
          this.toggleAddButton(shouldDisable, window.theme.variantStrings.soldOut);

        });
    }

    verifyPreorder(jsonPreorder) {
      if (!this.currentVariant) return;

      const variant = jsonPreorder[this.currentVariant.id];

      this.forcePreorderBehavior = variant.force_pre_order_behavior;
      this.preorder = variant.preorder;
      this.inventoryQuantity = variant.inventory_quantity;

      this.showReadyToShipBadge(); 
    }

    showReadyToShipBadge() {
      const readyToShipBadge = document.querySelector('.vg-badge-right .vg-img-right-first-image');
      if (!readyToShipBadge) return;

      if (this.preorder === 'continue' && (this.inventoryQuantity <= 0 || this.forcePreorderBehavior === 'true')) {
        readyToShipBadge.style.display = 'none';
      } else {
        readyToShipBadge.style.display = 'block';
      }
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const productTemplate = productForm.closest('.product-form').getAttribute('template');
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      if (!submitButtons) return;

      let label = null;
      if (this.currentVariant) {
        label = document.querySelector(`label[data-variant-id="${this.currentVariant.id}"]`);
      }
      let isClassDisable = false;
      let input = null;
      if (label) {
        const parent = label.parentElement;
        input = parent.querySelector('input[type="radio"]');
      }
      if (input && input.classList.contains('is-disabled')) {
        isClassDisable = true;
      }

      // Check if current variant has inventory policy "continue" (allow overselling)
      let hasInventoryPolicyContinue = false;
      if (this.currentVariant) {
        const variantSpan = document.querySelector(`span[data-variant-id="${this.currentVariant.id}"]`);
        if (variantSpan) {
          const inventoryPolicy = variantSpan.getAttribute('data-variant-preorder');
          hasInventoryPolicyContinue = inventoryPolicy === 'continue';
        }
      }

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable) {
          // If inventory policy is "continue" and variant is not available due to stock only, treat as pre-order
          if (hasInventoryPolicyContinue && this.currentVariant && !this.currentVariant.available) {
            // Allow the button to be enabled but use pre-order logic
            submitButton.removeAttribute('disabled');
            submitButton.classList.remove('klaviyo-bis-trigger');
            submitButton.classList.remove('sold-out');
            // The pre-order system will handle the button text and styling
          } else if (submitButton.classList.contains('not-klaviyo')) {
            if (document.querySelector('.rebuy-cart__flyout-item-property-value')) {
              text = window.theme.variantStrings.addToCart;
            }
            if (isClassDisable) {
              submitButton.setAttribute('disabled', 'disabled');
              text = 'SOLD OUT';
            }
          } else {
            submitButton.classList.add('klaviyo-bis-trigger');
            submitButton.classList.add('sold-out');
          }
          if (text) submitButtonText.textContent = text;
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('klaviyo-bis-trigger');
          submitButton.classList.remove('sold-out');
          submitButton.classList.remove('loading');

          // if (productTemplate?.includes('pre-order')) {
          //   submitButtonText.textContent = window.theme.variantStrings.preOrder;
          // } else {
            submitButtonText.textContent = window.theme.variantStrings.addToCart;
          // }
        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      // if (price) price.classList.add('visibility-hidden');
      // if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') {
        return;
      }

      this.showAllOptions();
      this.hideInvalidOptions();
      
      // Auto-select first valid option for each fieldset starting from the second one
      // if no option is selected or the selected option is invalid
      // BUT skip if this is an intentional deselection
      if (this.dataset.skipAutoSelect !== 'true') {
        for (let i = 1; i < this.fieldsets.length; i++) {
          this.autoSelectFirstValidOption(i);
        }
      }

      return true;
    }

    showAllOptions() {
      this.fieldsets.forEach((fieldset) => {
        fieldset.style.display = 'flex';

        if (fieldset.querySelector('select')) {
          fieldset.querySelectorAll('option').forEach(option => {
            option.disabled = false;
            option.style.display = 'block';
            option.style.pointerEvents = 'auto';
          });
        } else if (fieldset.querySelectorAll('input').length) {
          fieldset.querySelectorAll('input').forEach((input) => {
            input.classList.remove('is-disabled');
            input.style.display = 'block';
            input.style.pointerEvents = 'auto';

            const label = fieldset.querySelector(`label[for="${input.id}"]`);
            if (label) {
              label.style.display = 'inline-flex';
              label.style.pointerEvents = 'auto';
            }
            
            // Mostrar wrappers que podem ter sido escondidos
            const inputWrapper = input.closest('.variant-input-label');
            if (inputWrapper) {
              inputWrapper.style.display = '';
            }
            const parent = input.parentElement;
            if (parent && parent.style.display === 'none') {
              parent.style.display = '';
            }
          });
        }
      });
    }

    isValidCombination(testOptions, fieldsetIndex, validCombinations) {
      if (fieldsetIndex === 0) return true;

      return validCombinations.some(combination => {
        return testOptions.every((optionValue, index) => {
          if (index > fieldsetIndex) return true;
          const optionKey = `option${index + 1}`;
          return !optionValue || combination[optionKey] === optionValue;
        });
      });
    }

    isVariantSoldOut(testOptions, variant_data) {
      const hasAllOptions = testOptions.every(opt => opt && opt !== '');
      if (!hasAllOptions) return false;

      const matchingVariant = variant_data.find(variant => {
        return testOptions.every((optionValue, index) => {
          const optionKey = `option${index + 1}`;
          return variant[optionKey] === optionValue;
        });
      });

      return matchingVariant && !matchingVariant.available;
    }

    toggleInputOption(input, fieldset, hide) {
      const label = fieldset.querySelector(`label[for="${input.id}"]`);
      const inputWrapper = input.closest('.variant-input-label') || input.parentElement;

      if (hide) {
        if (inputWrapper && inputWrapper.classList.contains('variant-input-label')) {
          inputWrapper.style.display = 'none';
        } else {
          input.style.display = 'none';
          if (label) label.style.display = 'none';
          if (inputWrapper && inputWrapper.children.length <= 2) {
            inputWrapper.style.display = 'none';
          }
        }
      } else {
        if (inputWrapper && inputWrapper.classList.contains('variant-input-label')) {
          inputWrapper.style.display = '';
        } else {
          input.style.display = '';
          if (label) label.style.display = '';
          if (inputWrapper) inputWrapper.style.display = '';
        }
      }
    }

    resetFieldsetVisibility(fieldset) {
      if (fieldset.querySelector('select')) {
        fieldset.querySelectorAll('option').forEach(option => {
          option.style.display = '';
          option.disabled = false;
          option.classList.remove('is-disabled');
        });
      } else {
        fieldset.querySelectorAll('input').forEach(input => {
          const label = fieldset.querySelector(`label[for="${input.id}"]`);
          const wrapper = input.closest('.variant-input-label');
          input.style.display = '';
          input.classList.remove('is-disabled');
          input.disabled = false;
          if (label) {
            label.style.display = '';
            label.classList.remove('is-disabled');
            label.style.pointerEvents = 'auto';
          }
          if (wrapper) wrapper.style.display = '';
        });
      }
    }

    hideInvalidOptions() {
      const variant_data = this.getVariantData();
      if (!variant_data) return;

      const validCombinations = variant_data.map(variant => ({
        option1: variant.option1,
        option2: variant.option2,
        option3: variant.option3,
        available: variant.available
      }));

      this.fieldsets.forEach((fieldset, fieldsetIndex) => {
        const currentOptions = [...this.options];

        const isColorFieldset = this.isColorFieldsetElement(fieldset);

        if (fieldset.querySelector('select')) {
          fieldset.querySelectorAll('option').forEach(option => {
            if (!option.value) return;

            const testOptions = [...currentOptions];
            testOptions[fieldsetIndex] = option.value;

            const isValid = this.isValidCombination(testOptions, fieldsetIndex, validCombinations);
            const isSoldOut = isColorFieldset && isValid && this.isVariantSoldOut(testOptions, variant_data);

            if (!isValid) {
              option.style.display = 'none';
              option.disabled = true;
              option.classList.remove('is-disabled');
            } else if (isSoldOut) {
              option.style.display = 'block';
              option.disabled = false;
              option.classList.add('is-disabled');
            } else {
              option.style.display = 'block';
              option.disabled = false;
              option.classList.remove('is-disabled');
            }
          });

        } else {
          fieldset.querySelectorAll('input').forEach(input => {
            if (!input.value) return;

            const testOptions = [...currentOptions];
            testOptions[fieldsetIndex] = input.value;

            const isValid = this.isValidCombination(testOptions, fieldsetIndex, validCombinations);
            const isSoldOut = isColorFieldset && isValid && this.isVariantSoldOut(testOptions, variant_data);

            const label = fieldset.querySelector(`label[for="${input.id}"]`);

            this.toggleInputOption(input, fieldset, !isValid);

            if (!isValid) {
              if (isColorFieldset) input.classList.add('is-disabled');
              if (label) label.style.pointerEvents = 'none';
            } else if (isSoldOut) {
              input.classList.add('is-disabled');
              input.disabled = false;
              if (label) {
                label.classList.add('is-disabled');
                label.style.pointerEvents = 'auto';
              }
            } else {
              input.classList.remove('is-disabled');
              input.disabled = false;
              if (label) {
                label.classList.remove('is-disabled');
                label.style.pointerEvents = 'auto';
              }
            }
          });
        }
      });

      this.reorderColorOptions();
    }

    reorderColorOptions() {
      const colorFieldset = this.getColorFieldset();

      if (!colorFieldset) return;

      const isGrouped = colorFieldset.dataset.isGrouped === 'true';

      const sortByOriginalIndex = (a, b) =>
        parseInt(a.dataset.originalIndex || '9999', 10) -
        parseInt(b.dataset.originalIndex || '9999', 10);

      if (colorFieldset.querySelector('select')) {
        const select = colorFieldset.querySelector('select');
        const emptyOption = Array.from(select.options).find(opt => !opt.value);

        // Filtra apenas visíveis (exclui combinações inválidas com display:none)
        const visibleOptions = Array.from(select.options).filter(opt =>
          opt.value && opt.style.display !== 'none'
        );

        const availableSorted = visibleOptions
          .filter(opt => !opt.classList.contains('is-disabled'))
          .sort(sortByOriginalIndex);

        const soldOutSorted = visibleOptions
          .filter(opt => opt.classList.contains('is-disabled'))
          .sort(sortByOriginalIndex);

        const newOrder = [];
        if (emptyOption) newOrder.push(emptyOption);
        newOrder.push(...availableSorted, ...soldOutSorted);

        newOrder.forEach(option => select.appendChild(option));

      } else if (colorFieldset.querySelectorAll('input').length) {

        if (isGrouped) {
          // Cores agrupadas: reordena dentro de cada grupo (separado por <hr>)
          const allHrs = Array.from(colorFieldset.querySelectorAll('hr'));

          allHrs.forEach((hr, hrIndex) => {
            const previousHr = hrIndex > 0 ? allHrs[hrIndex - 1] : null;
            const startElement = previousHr ? previousHr.nextElementSibling : colorFieldset.firstElementChild;

            const groupDivs = [];
            let currentElement = startElement;

            while (currentElement && currentElement !== hr) {
              if (
                currentElement.tagName === 'DIV' &&
                currentElement.querySelector('input[type="radio"]') &&
                currentElement.getAttribute('style') &&
                currentElement.getAttribute('style').includes('position: relative')
              ) {
                const input = currentElement.querySelector('input[type="radio"]');
                if (input && input.value) {
                  groupDivs.push({ element: currentElement, input });
                }
              }
              currentElement = currentElement.nextElementSibling;
            }

            groupDivs.forEach(({ element }, index) => {
              if (!element.dataset.originalIndex) {
                element.dataset.originalIndex = index;
              }
            });

            const visibleDivs = groupDivs.filter(({ element, input }) =>
              element.style.display !== 'none' && input.style.display !== 'none'
            );

            const availableSorted = visibleDivs
              .filter(({ input }) => !input.classList.contains('is-disabled'))
              .sort((a, b) => sortByOriginalIndex(a.element, b.element));

            const soldOutSorted = visibleDivs
              .filter(({ input }) => input.classList.contains('is-disabled'))
              .sort((a, b) => sortByOriginalIndex(a.element, b.element));

            [...availableSorted, ...soldOutSorted].forEach(({ element }) => {
              hr.parentElement.insertBefore(element, hr);
            });
          });

        } else {
          // Cores não-agrupadas
          const container = colorFieldset.querySelector('.form__label__options') || colorFieldset;
          const inputs = Array.from(colorFieldset.querySelectorAll('input[type="radio"]'));

          const optionElements = inputs
            .filter(input => input.value)
            .map(input => ({
              element: input.closest('.variant-input-label') || input.parentElement,
              input
            }))
            .filter(({ element }) => element);

          // Salva índice original na primeira execução (usa data-original-order do Liquid se disponível)
          optionElements.forEach(({ element }, index) => {
            if (!element.dataset.originalIndex) {
              element.dataset.originalIndex = element.dataset.originalOrder ?? index;
            }
          });

          // Filtra apenas visíveis (exclui combinações inválidas com display:none)
          const visibleOptions = optionElements.filter(({ element, input }) =>
            element.style.display !== 'none' && input.style.display !== 'none'
          );

          const availableSorted = visibleOptions
            .filter(({ input }) => !input.classList.contains('is-disabled'))
            .sort((a, b) => sortByOriginalIndex(a.element, b.element));

          const soldOutSorted = visibleOptions
            .filter(({ input }) => input.classList.contains('is-disabled'))
            .sort((a, b) => sortByOriginalIndex(a.element, b.element));

          [...availableSorted, ...soldOutSorted].forEach(({ element }) => {
            container.appendChild(element);
          });
        }
      }
    }

    markCurrentVariantOptionsAsSoldOut() {
      if (!this.currentVariant || !this.currentVariant.options) return;
      
      this.fieldsets.forEach((fieldset, fieldsetIndex) => {
        const optionValue = this.currentVariant.options[fieldsetIndex];
        if (!optionValue) return;
        
        if (fieldset.querySelector('select')) {
          const option = Array.from(fieldset.querySelectorAll('option')).find(
            opt => opt.value === optionValue
          );
          if (option) {
            option.classList.add('is-disabled'); // Keep class for visual styling
            option.disabled = false; // Allow selection
          }
        } else if (fieldset.querySelectorAll('input').length) {
          const input = fieldset.querySelector(`input[value="${optionValue}"]`);
          if (input) {
            input.classList.add('is-disabled'); // Keep class for visual styling
            input.disabled = false; // Allow selection
            const label = fieldset.querySelector(`label[for="${input.id}"]`);
            if (label) {
              label.style.pointerEvents = 'auto'; // Allow clicking
            }
          }
        }
      });
    }

    // (nova implementação de hideInvalidOptions inserida acima)

    markVariantsDisabledForNonExistentColor() {
      const variant_data = this.getVariantData();
      if (!variant_data) return;

      const colorFieldset = this.fieldsets.find(fs => {
        return this.isColorFieldsetElement(fs);
      });

      if (!colorFieldset) return;

      const selectedColorInput = colorFieldset.querySelector('input:checked');
      const selectedColorSelect = colorFieldset.querySelector('select');
      const selectedColor = selectedColorInput?.value || selectedColorSelect?.value;

      if (!selectedColor) return;

      const colorFieldsetIndex = this.fieldsets.indexOf(colorFieldset);
      const currentOptions = [...this.options];

      this.fieldsets.forEach((fieldset, fieldsetIndex) => {
        if (fieldsetIndex === colorFieldsetIndex) return;

        if (fieldset.querySelector('select')) {
          fieldset.querySelectorAll('option').forEach(option => {
            if (!option.value) return;

            const testOptions = [...currentOptions];
            testOptions[fieldsetIndex] = option.value;
            testOptions[colorFieldsetIndex] = selectedColor;

            const combinationExists = variant_data.some(variant => {
              return testOptions.every((optionValue, index) => {
                const optionKey = `option${index + 1}`;
                return !optionValue || variant[optionKey] === optionValue;
              });
            });

            if (!combinationExists) {
              option.classList.add('is-disabled');
              option.disabled = false;
            } else {
              const matchingVariant = variant_data.find(variant => {
                return testOptions.every((optionValue, index) => {
                  const optionKey = `option${index + 1}`;
                  return !optionValue || variant[optionKey] === optionValue;
                });
              });

              if (matchingVariant) {
                if (matchingVariant.available) {
                  option.classList.remove('is-disabled');
                } else {
                  option.classList.add('is-disabled');
                }
              } else {
                option.classList.remove('is-disabled');
              }
            }
          });
        } else if (fieldset.querySelectorAll('input').length) {
          fieldset.querySelectorAll('input').forEach((input) => {
            if (!input.value) return;

            const testOptions = [...currentOptions];
            testOptions[fieldsetIndex] = input.value;
            testOptions[colorFieldsetIndex] = selectedColor;

            const combinationExists = variant_data.some(variant => {
              return testOptions.every((optionValue, index) => {
                const optionKey = `option${index + 1}`;
                return !optionValue || variant[optionKey] === optionValue;
              });
            });

            const label = fieldset.querySelector(`label[for="${input.id}"]`);

            if (!combinationExists) {
              input.classList.add('is-disabled');
              input.disabled = false;
            } else {
              const matchingVariant = variant_data.find(variant => {
                return testOptions.every((optionValue, index) => {
                  const optionKey = `option${index + 1}`;
                  return !optionValue || variant[optionKey] === optionValue;
                });
              });

              if (matchingVariant) {
                if (matchingVariant.available) {
                  input.classList.remove('is-disabled');
                  if (label) {
                    label.classList.remove('is-disabled');
                  }
                } else {
                  input.classList.add('is-disabled');
                  if (label) {
                    label.classList.add('is-disabled');
                  }
                }
              } else {
                input.classList.remove('is-disabled');
                if (label) {
                  label.classList.remove('is-disabled');
                }
              }
            }
          });
        }
      });
    }

    autoSelectFirstValidOption(fieldsetIndex) {
      if (fieldsetIndex < 0 || fieldsetIndex >= this.fieldsets.length) {
        return;
      }

      const targetFieldset = this.fieldsets[fieldsetIndex];
      if (!targetFieldset) {
        return;
      }

      // Check if there's already a selected option that is still valid
      const selectedInput = targetFieldset.querySelector('input:checked');
      const selectedSelect = targetFieldset.querySelector('select');
      const selectedValue = selectedInput?.value || (selectedSelect?.value || '');

      // Check if the currently selected option is still visible/valid
      if (selectedValue) {
        if (selectedInput) {
          const label = targetFieldset.querySelector(`label[for="${selectedInput.id}"]`);
          const inputWrapper = selectedInput.closest('.variant-input-label');
          // Allow sold out colors to remain selected (is-disabled is only for styling)
          const isStillVisible = selectedInput.style.display !== 'none' &&
                                (!label || label.style.display !== 'none') &&
                                (!inputWrapper || inputWrapper.style.display !== 'none') &&
                                !selectedInput.disabled;

          if (isStillVisible) {
            return;
          }
        } else if (selectedSelect) {
          const selectedOption = Array.from(selectedSelect.options).find(opt => opt.value === selectedValue);
          if (selectedOption && selectedOption.style.display !== 'none' && !selectedOption.disabled) {
            return;
          }
        }
      }

      // Find the first visible/available option (prefer available over sold out)
      if (targetFieldset.querySelector('select')) {
        const select = targetFieldset.querySelector('select');
        // First try to find an available option (not sold out)
        let firstVisibleOption = Array.from(select.options).find(option => {
          return option.value && 
                 option.style.display !== 'none' && 
                 !option.disabled &&
                 !option.classList.contains('is-disabled');
        });
        
        // If no available option, allow sold out options
        if (!firstVisibleOption) {
          firstVisibleOption = Array.from(select.options).find(option => {
            return option.value && 
                   option.style.display !== 'none' && 
                   !option.disabled;
          });
        }
        
        if (firstVisibleOption && firstVisibleOption.value !== selectedValue) {
          select.value = firstVisibleOption.value;
          firstVisibleOption.classList.remove('is-disabled');
          this.updateOptions();
        }
      } else if (targetFieldset.querySelectorAll('input').length) {
        // First try to find an available option (not sold out)
        let firstVisibleInput = Array.from(targetFieldset.querySelectorAll('input')).find(input => {
          if (!input.value) return false;
          
          const label = targetFieldset.querySelector(`label[for="${input.id}"]`);
          const inputWrapper = input.closest('.variant-input-label');
          
          return input.style.display !== 'none' && 
                 (!label || label.style.display !== 'none') &&
                 (!inputWrapper || inputWrapper.style.display !== 'none') &&
                 !input.disabled &&
                 !input.classList.contains('is-disabled');
        });
        
        if (!firstVisibleInput) {
          firstVisibleInput = Array.from(targetFieldset.querySelectorAll('input')).find(input => {
            if (!input.value) return false;
            
            const label = targetFieldset.querySelector(`label[for="${input.id}"]`);
            const inputWrapper = input.closest('.variant-input-label');
            
            return input.style.display !== 'none' && 
                   (!label || label.style.display !== 'none') &&
                   (!inputWrapper || inputWrapper.style.display !== 'none') &&
                   !input.disabled;
          });
        }
        
        if (firstVisibleInput && !firstVisibleInput.checked) {
          firstVisibleInput.checked = true;
          firstVisibleInput.classList.remove('is-disabled');
          const label = targetFieldset.querySelector(`label[for="${firstVisibleInput.id}"]`);
          if (label) {
            label.classList.remove('is-disabled');
          }
          this.updateOptions();
        }
      }
    }

    // Keep old method for backward compatibility
    autoSelectFirstPackOption() {
      // Find Pack Options fieldset index
      const packOptionsFieldsetIndex = this.fieldsets.findIndex(fieldset => {
        const handle = fieldset.dataset.handle || '';
        const label = fieldset.querySelector('.form__label')?.textContent || '';
        return handle.toLowerCase().includes('pack') || 
               label.toLowerCase().includes('pack');
      });

      if (packOptionsFieldsetIndex >= 0) {
        this.autoSelectFirstValidOption(packOptionsFieldsetIndex);
      }
    }

    normalizeString(str) {
      if (!str) return '';
      
      return str
        .toLowerCase()
        .trim()
        .replace(/[àáâãäå]/g, 'a')
        .replace(/[èéêë]/g, 'e')
        .replace(/[ìíîï]/g, 'i')
        .replace(/[òóôõö]/g, 'o')
        .replace(/[ùúûü]/g, 'u')
        .replace(/[ñ]/g, 'n')
        .replace(/[ç]/g, 'c')
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]/g, '')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');
    }

    getImageSetName(variant_name) {
      return this.normalizeString(variant_name);
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]')?.dataset.index || 'option2';
        this.setImageSetMedia();
      }
    }

    // Função para comparar arrays
    arraysEqual(arr1, arr2) {
      if (!arr1 || !arr2 || arr1.length !== arr2.length) return false;
      return arr1.every(val => arr2.includes(val)) && arr2.every(val => arr1.includes(val));
    }

    arraysMatch(variantGroup, imageGroup) {
      if (!variantGroup || !imageGroup || imageGroup.length === 0) return false;
      
      // Filtrar "dimension" de ambos os arrays antes de comparar
      const filteredVariantGroup = variantGroup.filter(val => val !== 'dimension');
      const filteredImageGroup = imageGroup.filter(val => val !== 'dimension');
      
      if (filteredImageGroup.length === 0) return false;
      
      return filteredImageGroup.every(val => filteredVariantGroup.includes(val));
    }

    // Função para extrair grupo de dados
    extractGroupFromDataset(datasetGroup, imageSetName) {
      if (!datasetGroup || !imageSetName) return [];
      
      const groupPart = datasetGroup.split(`${imageSetName}_`);
      if (groupPart.length < 2) return [];
      
      return groupPart[1].split('_').filter(Boolean);
    }

    updatePreOrder() {
      if (!this.currentVariant) return;

      const selectedLabel = document.querySelector(`label[data-variant-id="${this.currentVariant.id}"]`);
      if (selectedLabel) {
        const input = selectedLabel.previousElementSibling;
        if (input && input.classList.contains('is-disabled')) return;
      }

      const elements = this.getDOMElements();
      if (!elements) return;
      
      // Check if current variant has inventory policy "continue" and no stock
      const variantSpan = document.querySelector(`span[data-variant-id="${this.currentVariant.id}"]`);
      let hasInventoryPolicyContinue = false;
      let inventoryQuantity = 0;
      if (variantSpan) {
        const inventoryPolicy = variantSpan.getAttribute('data-variant-preorder');
        inventoryQuantity = parseInt(variantSpan.getAttribute('data-variant-quantity')) || 0;
        hasInventoryPolicyContinue = inventoryPolicy === 'continue';
      }
      
      // If variant has inventory policy "continue" and no stock, treat it as pre-order
      if (hasInventoryPolicyContinue && inventoryQuantity <= 0 && !this.currentVariant.available) {
        // Show as pre-order when stock is zero but policy allows continue
        elements.buttonSubmitText.textContent = window.theme.variantStrings.preOrder;
        elements.buttonSubmit.classList.add('pre-order');
        elements.buttonSubmit.removeAttribute('disabled');
        elements.buttonSubmit.classList.remove('sold-out', 'klaviyo-bis-trigger');
        return;
      }

      if (!this.currentVariant.available && !hasInventoryPolicyContinue) {
        return;
      }

      // Store current pre-order state to avoid unnecessary flickering
      const currentPreOrderMessage = elements.productAddContainer.querySelector('.preorder-message');
      const currentButtonText = elements.buttonSubmitText.textContent;
      const currentButtonClasses = [...elements.buttonSubmit.classList];
      const currentButtonStyle = elements.buttonSubmit.style.cssText;

      let productChildrens = window.productChildrens?.variants;
      let variantIds = productChildrens?.find(item => item.id === this.currentVariant.id)?.product_childrens;
      if (!Array.isArray(variantIds) || variantIds.length === 0) {
        variantIds = 'gid://shopify/ProductVariant/' + this.currentVariant.id;
      } else {
        variantIds = variantIds.map(id => `gid://shopify/ProductVariant/${id}`).join(',');
      }

      // Add loading state with smooth transition
      elements.buttonSubmit.style.transition = 'opacity 0.2s ease';
      elements.buttonSubmit.style.opacity = '0.7';
      elements.buttonSubmit.style.pointerEvents = 'none';

      const url = `https://lionfish-app-zikm2.ondigitalocean.app/api/get-product?variantIds=${variantIds}&variantId=gid://shopify/ProductVariant/${this.currentVariant.id}`;

      // Extract product handle from the dataset.url (e.g., "/products/goto-sofa-three-seater")
      const productHandle = this.dataset.url ? this.dataset.url.split('/products/')[1]?.split('?')[0] : null;

      fetch(url)
        .then(res => res.json())
        .then(preOrderData => {
          const productParent = preOrderData?.productParent;

          if (productParent && preOrderData?.result) {
            preOrderData.result = preOrderData.result.map(item => ({
              ...item,
              parentProduct: productParent
            }));
          }

          const data = findEarliestValidContainerItem(preOrderData?.result, variantIds, productHandle);

          // Only clear and update if the state actually changes
          const shouldShowPreOrder = data?.template && data && this.isPreOrderActive(data);
          const hasCurrentPreOrder = currentPreOrderMessage !== null;

          if (shouldShowPreOrder !== hasCurrentPreOrder ||
            (shouldShowPreOrder && this.hasPreOrderContentChanged(data, currentPreOrderMessage, currentButtonText))) {

            this.clearPreOrderUI(elements);

            if (shouldShowPreOrder) {
              this.renderPreOrderMessage(data, elements.productAddContainer);
              this.updateAddToCartButton(data, elements.buttonSubmit, elements.buttonSubmitText);
              this.insertPreOrderHiddenInput(data, elements.form);
            } else {
              // Reset to default state
              elements.buttonSubmitText.textContent = window.theme.variantStrings.addToCart;
              elements.buttonSubmit.className = elements.buttonSubmit.className.replace(/\s*(pre-order|sold-out|loading)\s*/g, ' ').trim();
              elements.buttonSubmit.style.cssText = '';
              elements.buttonSubmit.removeAttribute('disabled');
            }
          } else if (!shouldShowPreOrder) {
            // Ensure default state without flickering
            elements.buttonSubmitText.textContent = window.theme.variantStrings.addToCart;
            elements.buttonSubmit.className = elements.buttonSubmit.className.replace(/\s*(pre-order|sold-out|loading)\s*/g, ' ').trim();
            elements.buttonSubmit.style.cssText = '';
            elements.buttonSubmit.removeAttribute('disabled');
          }
        })
        .catch(err => {
          console.error('Err:', err);
          // Reset to default state on error
          elements.buttonSubmitText.textContent = window.theme.variantStrings.addToCart;
          elements.buttonSubmit.className = elements.buttonSubmit.className.replace(/\s*(pre-order|sold-out|loading)\s*/g, ' ').trim();
          elements.buttonSubmit.style.cssText = '';
          elements.buttonSubmit.removeAttribute('disabled');
        })
        .finally(() => {
          // Remove loading state with smooth transition
          setTimeout(() => {
            elements.buttonSubmit.style.opacity = '1';
            elements.buttonSubmit.style.pointerEvents = 'auto';
            setTimeout(() => {
              elements.buttonSubmit.style.transition = '';
            }, 200);
          }, 100);
        });
    }

    getDOMElements() {
      const buttonSubmit = document.querySelector('.single-add-to-cart-button');
      const buttonSubmitText = buttonSubmit?.querySelector('.single-add-to-cart-button--text');
      const productAddContainer = document.querySelector('.product-add-to-cart-container');
      const productForm = document.querySelector('product-form');
      const form = productForm?.querySelector('form');

      if (!buttonSubmit || !buttonSubmitText || !productAddContainer || !form) return null;

      return { buttonSubmit, buttonSubmitText, productAddContainer, form };
    }

    clearPreOrderUI({ productAddContainer, form }) {
      productAddContainer.querySelector('.preorder-message')?.remove();
      form.querySelector('#preorder-label')?.remove();
    }

    hasPreOrderContentChanged(data, currentMessage, currentButtonText) {
      if (!data?.template) return false;

      const newMessageText = data.template?.messageSettings?.preOrderMessage || window.theme.variantStrings.preOrder;
      const newButtonText = data.template?.buttonSettings?.preOrderButtonText || window.theme.variantStrings.preOrder;

      const currentMessageText = currentMessage ? currentMessage.textContent : '';

      return currentMessageText !== newMessageText || currentButtonText !== newButtonText;
    }

    removePreOrderMessage() {
      removePreOrderMessage();
    }

    isPreOrderActive(data) {
      let currentDate = new Date();
      if (data?.startDate) {
        let startDate = new Date(data.startDate);
        if (startDate > currentDate) {
          setTimeout(() => {
            this.changeButtonNotifyAvailable();
          }, 100);
          return false;
        }
      }
      if (data?.endDate) {
        let endDate = new Date(data.endDate);
        if (endDate < currentDate) {
          setTimeout(() => {
            this.changeButtonNotifyAvailable();
          }, 100);
          return false;
        }
      }
      return true;
    }

    changeButtonNotifyAvailable() {
      const button = document.querySelector('.single-add-to-cart-button');
      const buttonText = button?.querySelector('.single-add-to-cart-button--text');
      if (button && buttonText) {
        button.classList.add('klaviyo-bis-trigger');
        buttonText.textContent = "NOTIFY ME WHEN AVAILABLE";
      }
    }

    isStockEligible(settings, availableQuantity) {
      const { stockManagement, productQuantity, unlimitedInventory } = settings;

      if (
        (stockManagement === 'outOfStock' && availableQuantity > 1) ||
        (stockManagement === 'available' && availableQuantity < 1)
      ) return false;

      if (!unlimitedInventory && productQuantity < 1) return false;

      return true;
    }

    renderPreOrderMessage(data, container) {
      const {
        preOrderMessage = window.theme.variantStrings.preOrder,
        placement = 'above',
        fontSize = '13',
        fontWeight = '300',
        fontColor = '#000',
        fontStyle = 'normal',
        fontAlign = 'center'
      } = data.template?.messageSettings || {};

      const div = document.createElement('div');
      div.className = 'preorder-message';
      div.style.cssText = `
        font-size: ${fontSize}px;
        color: ${fontColor};
        text-align: ${fontAlign};
        font-weight: ${fontWeight};
        font-style: ${fontStyle};
        margin: 10px 0;
      `;
      div.textContent = preOrderMessage;
      placement === "above" ? container.prepend(div) : container.append(div);
    }

    updateAddToCartButton(data, button, buttonTextEl) {
      if (!data.template?.buttonSettings) return;
      const settings = data.template?.buttonSettings;
      const {
        preOrderButtonText = window.theme.variantStrings.preOrder,
        backgroundColor = '#ffffff',
        fontSize = '14',
        fontWeight = '300',
        fontColor = '#5e7080'
      } = settings;
      buttonTextEl.textContent = preOrderButtonText || window.theme.variantStrings.preOrder;
      if (!settings?.isCustom) return;

      button.classList.add('pre-order');
      button.style.cssText = `
        background-color: ${backgroundColor};
        font-size: ${fontSize}px;
        font-weight: ${fontWeight};
      `;

      button.classList.remove('sold-out', 'loading');
      button.removeAttribute('disabled');
    }

    insertPreOrderHiddenInput(data, form) {
      const settings = data.template?.cartPreOrderSettings;
      // if (!settings?.enabled) return;

      const input = document.createElement('input');
      input.type = 'hidden';
      input.id = 'preorder-label';
      input.name = `properties[${settings.title}]`;
      input.value = settings.label || '';
      form.appendChild(input);
    }

    setImageSetMedia() {
      if (!this.imageSetIndex || !this.currentVariant?.options) {
        return;
      }

      const normalizedGroup = this.currentVariant.options.map(option => 
        this.normalizeString(option)
      );
      
      // Procurar tanto no productSlider quanto no document (para o caso do Swiper)
      let selectedSetImages = this.productSlider.querySelectorAll(`[data-set-name="${this.imageSetName}"]`);
      
      if (!selectedSetImages.length) {
        // Tentar buscar no document inteiro (para Swiper que pode estar em outro contexto)
        selectedSetImages = document.querySelectorAll(`[data-set-name="${this.imageSetName}"]`);
      }
      
      if (!selectedSetImages.length) return;

      if (this.hideVariants) {
        selectedSetImages.forEach(thumb => {
          if (!thumb.dataset.group) return;
          
          const elementGroup = this.extractGroupFromDataset(thumb.dataset.group, this.imageSetName);
          const isActive = this.arraysMatch(normalizedGroup, elementGroup);
          
          thumb.classList.toggle('is-active', isActive);
        });
      } else {
        const activeImages = Array.from(selectedSetImages).filter(element => {
          if (!element.dataset.group) return false;
          
          const elementGroup = this.extractGroupFromDataset(element.dataset.group, this.imageSetName);
          return this.arraysMatch(normalizedGroup, elementGroup);
        });

        activeImages.forEach(thumb => {
          if (thumb.parentElement) thumb.parentElement.prepend(thumb);
        });
      }

      setTimeout(() => {
        this.productSlider.querySelector('product-slider')?.onPaginationResize();
      }, 100);
    }

    updateThumbnailsForVariant() {
      if (!window.swiperSlidesCache || !window.swiperSlidesCache.mainHTML.length) {
        return;
      }
      
      if (!this.imageSetName || !this.currentVariant) {
        return;
      }
      
      const mainSwiper = document.querySelector('.product-main-swiper');
      const thumbsSwiper = document.querySelector('.product-thumbnails-swiper');
      
      if (mainSwiper && mainSwiper.swiper) {
        this.reinitializeSwipers(mainSwiper, thumbsSwiper);
      }
    }
    
    reinitializeSwipers(mainSwiper, thumbsSwiper) {
      if (!mainSwiper || !mainSwiper.swiper) {
        return;
      }
      
      const main = mainSwiper.swiper;
      const thumbs = thumbsSwiper?.swiper;
      
      if (!window.swiperSlidesCache) {
        window.swiperSlidesCache = {
          mainHTML: [],
          thumbsHTML: []
        };
        return;
      }
      
      const imageSetName = this.imageSetName;
      const normalizedGroup = this.currentVariant.options.map(option =>
        this.normalizeString(option)
      );
      
      const mainFiltered = window.swiperSlidesCache.mainHTML.filter(html => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        const slide = tempDiv.firstElementChild;
        const datasetGroup = slide?.getAttribute('data-group');
        
        if (!datasetGroup) return true;
        
        const elementGroup = this.extractGroupFromDataset(datasetGroup, imageSetName);
        return this.arraysMatch(normalizedGroup, elementGroup);
      });
      
      // Ordenar slides do main carousel filtrados pelo índice original para manter ordem correta
      const mainFilteredSorted = mainFiltered.map(html => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        const slide = tempDiv.firstElementChild;
        const slideIndex = parseInt(slide?.getAttribute('data-slide-index') || '0', 10);
        return { html, index: slideIndex };
      }).sort((a, b) => a.index - b.index).map(item => item.html);
      
      const thumbsFiltered = window.swiperSlidesCache.thumbsHTML.filter(html => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        const slide = tempDiv.firstElementChild;
        const datasetGroup = slide?.getAttribute('data-group');
        
        // Imagens compartilhadas (sem grupo) sempre visíveis
        if (!datasetGroup) return true;
        
        const elementGroup = this.extractGroupFromDataset(datasetGroup, imageSetName);
        return this.arraysMatch(normalizedGroup, elementGroup);
      });
      
      // Ordenar thumbnails filtradas pelo índice original para manter ordem correta
      const thumbsFilteredSorted = thumbsFiltered.map(html => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        const slide = tempDiv.firstElementChild;
        const slideIndex = parseInt(slide?.getAttribute('data-slide-index') || '0', 10);
        return { html, index: slideIndex };
      }).sort((a, b) => a.index - b.index).map(item => item.html);

      const mainHTML = mainFilteredSorted.length ? mainFilteredSorted : window.swiperSlidesCache.mainHTML;
      const thumbsHTML = thumbsFilteredSorted.length ? thumbsFilteredSorted : window.swiperSlidesCache.thumbsHTML;
      
      main.removeAllSlides();
      if (thumbs) {
        thumbs.removeAllSlides();
      }
      
      main.appendSlide(mainHTML);
      if (thumbs) {
        thumbs.appendSlide(thumbsHTML);
      }
      
      requestAnimationFrame(() => {
        main.update();
        if (thumbs) {
          thumbs.update();
        }
        
        main.slideTo(0, 0, false);
        if (thumbs) {
          thumbs.slideTo(0, 0, false);
        }
        
        if (main.params && main.params.on && main.params.on.slideChange) {
          main.off('slideChange');
        }
        
        // Adiciona novo listener de sincronização
        main.on('slideChange', () => {
          if (thumbs) {
            thumbs.slideTo(main.realIndex, 0, false);
          }
        });
      });
    }

    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }

    getVariantData() {
      this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }

    updateVariantCustomBadges() {
      if (!this.currentVariant) return;

      const badgeDataElement = document.getElementById('variant-badges-data');
      if (!badgeDataElement) return;
      
      let allVariantBadges = {};
      try {
        allVariantBadges = JSON.parse(badgeDataElement.textContent);
      } catch (e) {
        console.log('Error parsing variant badges data:', e);
        return;
      }
      
      const badgeContainers = document.querySelectorAll('.vg-badge-left');
      const variantId = this.currentVariant.id;
      const variantBadges = allVariantBadges[variantId];

      if (variantBadges && variantBadges.badges && Array.isArray(variantBadges.badges)) {
        badgeContainers.forEach(container => {
          container.innerHTML = '';
          this.renderBadges(container, variantBadges.badges);
        });
      }
    }

    renderBadges(container, badges) {
      if (!badges || !Array.isArray(badges)) return;
      
      badges.forEach(badge => {
        const badgeElement = this.createBadgeElement(badge);
        container.appendChild(badgeElement);
      });
    }

    createBadgeElement(badge) {
      const badgeElement = document.createElement('span');
      badgeElement.className = 'badge badge-custom-icon';
      
      if (badge.image) {
        const img = document.createElement('img');
        img.src = badge.image;
        img.className = 'badge badge-custom badge-custom-image';
        img.style.width = `${badge.image_width || 100}px`;
        img.loading = 'lazy';

        return img;
      } else {
        badgeElement.style.backgroundColor = badge.background_color || '#000000';
        badgeElement.style.borderColor = badge.background_color || '#000000';
        badgeElement.style.color = badge.text_color || '#ffffff';
        
        if (badge.icon) {
          const icon = document.createElement('img');
          icon.src = badge.icon;
          icon.className = 'badge-custom';
          icon.style.width = `${badge.icon_width || 16}px`;
          icon.loading = 'lazy';
          badgeElement.appendChild(icon);
        }
        
        const text = document.createElement('span');
        text.textContent = badge.text;
        badgeElement.appendChild(text);
        
        return badgeElement;
      }
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}
//HERE
if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.pagination = this.parentElement.querySelector('.product-images-buttons');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');

      // thumbnails - add a small delay to ensure they're rendered
      setTimeout(() => {
        const sectionId = this.closest('[id^="MediaGallery-"]').id.split('-')[1];
        const thumbnails = document.querySelector(`#Product-Thumbnails-${sectionId}`);
        if (thumbnails) {
          this.setupThumbnails(thumbnails);
        } else {
          // Fallback: try to find any thumbnails
          const fallbackThumbnails = document.querySelector('.product-thumbnails-slider');
          if (fallbackThumbnails) {
            this.setupThumbnails(fallbackThumbnails);
          }
        }
      }, 100);

      // Start Gallery
      let observer = new MutationObserver(() => {
        this.setupProductGallery();
        const thumbnails = document.querySelector(`#Product-Thumbnails-${this.closest('[id^="MediaGallery-"]').id.split('-')[1]}`);
        if (thumbnails) this.setupThumbnails(thumbnails);
      });

      observer.observe(this, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        characterData: false
      });

      this.setupProductGallery();

      // Start Pagination
      if (this.pagination) {
        this.setupPagination();
        this.resizeObserver = new ResizeObserver(entries => {
          this.onPaginationResize();
          this.refreshSliderPositions();
        });
        this.resizeObserver.observe(this);
        this.addEventListener('scroll', this.updatePagination.bind(this));
      }

      // Refresh positions after a short delay to ensure layout is complete
      setTimeout(() => {
        this.refreshSliderPositions();
      }, 200);
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }

      this.setEventListeners();
    }
    buildItems(activeImages) {
      let images = activeImages.map((item) => {
        if (!item.querySelector('.product-single__media-zoom')) return;
        let activelink = item.querySelector('.product-single__media-zoom');
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h,
          title: activelink.getAttribute('title')
        };
      });
      return images;
    }
    setEventListeners() {
      let activeImages = Array.from(this.querySelectorAll('.product-images__slide--image')).filter(element => element.clientWidth > 0),
        items = this.buildItems(activeImages),
        captionEl = this.dataset.captions,
        pswpElement = document.querySelectorAll('.pswp')[0],
        options = {
          maxSpreadZoom: 2,
          loop: false,
          allowPanToNext: false,
          closeOnScroll: false,
          showHideOpacity: false,
          arrowKeys: true,
          history: false,
          captionEl: captionEl,
          fullscreenEl: false,
          zoomEl: false,
          shareEl: false,
          counterEl: true,
          arrowEl: true,
          preloaderEl: true
        };

      let openPswp = function (e, link, options, pswpElement, items) {
        let parent = link.closest('.product-images__slide');
        let i = activeImages.indexOf(parent);
        options.index = parseInt(i, 10);
        options.getThumbBoundsFn = () => {
          const thumbnail = link.closest('.product-single__media'),
            pageYScroll = window.scrollY || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        };
        if (typeof PhotoSwipe !== 'undefined') {
          let pswp = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

          pswp.listen('firstUpdate', () => {
            pswp.listen('parseVerticalMargin', function (item) {
              item.vGap = {
                top: 50,
                bottom: 50
              };
            });
          });
          pswp.init();
        }
        e.preventDefault();
      };
      this.querySelectorAll('.product-single__media-zoom').forEach(function (link) {
        let thumbnail = link.closest('.product-single__media');
        let clone = link.cloneNode(true);
        thumbnail.append(clone);
        link.remove();
        clone.addEventListener('click', (e) => openPswp(e, clone, options, pswpElement, items));
      });

    }
    setupPagination() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;

      this.currentPageElement = this.pagination.querySelector('.slider-counter--current');
      this.pageTotalElement = this.pagination.querySelector('.slider-counter--total');

      this.prevButton = this.pagination.querySelector('button[name="previous"]');
      this.nextButton = this.pagination.querySelector('button[name="next"]');


      this.prevButton.addEventListener('click', this.onPaginationButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onPaginationButtonClick.bind(this));

      this.updatePagination();
    }
    onPaginationResize() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);

      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.updatePagination();
    }
    onPaginationButtonClick(event) {
      event.preventDefault();
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.scrollLeft + (1 * this.sliderItemOffset) : this.scrollLeft - (1 * this.sliderItemOffset);
      this.scrollTo({
        left: this.slideScrollPosition
      });
    }
    updatePagination() {
      if (!this.nextButton) return;

      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.scrollLeft / this.sliderItemOffset) + 1;

      if (this.currentPageElement) {
        this.currentPageElement.textContent = this.currentPage;
      }
      if (this.pageTotalElement) {
        this.pageTotalElement.textContent = this.sliderItemsToShow.length;
      }

      if (this.currentPage != previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1]
          }
        }));
      }

      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.clientWidth + this.scrollLeft - offset;
      return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.scrollLeft;
    }
    setupThumbnails(thumbnailsEl) {
  // Find thumbnails for this section
  const sectionId = this.closest('[id^="MediaGallery-"]').id.split('-')[1];
  const thumbnails = thumbnailsEl || document.querySelector(`#Product-Thumbnails-${sectionId}`);
  if (!thumbnails) {
    return;
  }

  // Wait a bit to ensure variant filtering and DOM updates are done
  requestAnimationFrame(() => {
    const thumbItems = Array.from(thumbnails.querySelectorAll('.product-thumbnails-slider__item'))
      .filter(el => el.offsetParent !== null && el.style.display !== 'none'); // only visible thumbs
    const sliderItems = Array.from(this.querySelectorAll('.product-images__slide'))
      .filter(el => el.offsetParent !== null && el.style.display !== 'none'); // only visible slides

    if (!thumbItems.length || !sliderItems.length) {
      // Try to setup even if thumbnails appear hidden
      if (thumbnails.querySelectorAll('.product-thumbnails-slider__item').length > 0) {
        const allThumbItems = Array.from(thumbnails.querySelectorAll('.product-thumbnails-slider__item'));
        this.setupThumbnailSync(thumbnails, allThumbItems, sliderItems);
        return;
      }
      return;
    }

    // Setup thumbnails immediately, but also refresh after images load
    this.setupThumbnailSync(thumbnails, thumbItems, sliderItems);
    
    // Also refresh positions after images load
    const images = this.querySelectorAll('img');
    let loadedImages = 0;
    const totalImages = images.length;
    
    if (totalImages > 0) {
      images.forEach(img => {
        if (img.complete) {
          loadedImages++;
        } else {
          img.addEventListener('load', () => {
            loadedImages++;
            if (loadedImages === totalImages) {
              this.refreshSliderPositions();
            }
          });
        }
      });
      
      if (loadedImages === totalImages) {
        this.refreshSliderPositions();
      }
    }
    
    // Fallback timeout to ensure setup happens
    setTimeout(() => {
      this.refreshSliderPositions();
    }, 500);
  });
}

setupThumbnailSync(thumbnails, thumbItems, sliderItems) {
  // Make sure we know each slide's offset
  this.sliderItemsToShow = sliderItems;
  this.sliderItemOffset = this.sliderItemsToShow[1]
    ? this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft
    : this.sliderItemsToShow[0].offsetWidth;

  // --- CLICK SYNC ---
  thumbItems.forEach((thumb, index) => {
    thumb.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      // Use actual offset position instead of calculated offset
      let scrollLeft;
      if (index < this.sliderItemsToShow.length) {
        scrollLeft = this.sliderItemsToShow[index].offsetLeft;
      } else {
        // Fallback to calculated offset
        scrollLeft = index * this.sliderItemOffset;
      }

      this.scrollTo({
        left: scrollLeft,
        behavior: 'smooth'
      });

      // Update pagination counter
      if (typeof this.updatePagination === 'function') {
        this.updatePagination();
      }

      // Highlight active thumb
      thumbItems.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      
      // Dispatch custom event for any other components that might need to know
      this.dispatchEvent(new CustomEvent('thumbnailClicked', {
        detail: {
          index: index,
          thumb: thumb
        }
      }));
    });
  });

  // --- MAIN SLIDER → THUMB SYNC ---
  this.addEventListener('slideChanged', (event) => {
    const currentIndex = event.detail.currentPage - 1;
    if (currentIndex < 0) return;

    thumbItems.forEach((thumb, i) => {
      thumb.classList.toggle('is-active', i === currentIndex);
    });

    // Keep active thumb visible
    const activeThumb = thumbnails.querySelector('.is-active');
    if (activeThumb) {
      activeThumb.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      });
    }
  });

  // Set first thumb as active initially
  if (thumbItems.length) thumbItems[0].classList.add('is-active');
}

// Method to refresh thumbnail synchronization when variants change
refreshThumbnailSync() {
  const sectionId = this.closest('[id^="MediaGallery-"]').id.split('-')[1];
  const thumbnails = document.querySelector(`#Product-Thumbnails-${sectionId}`);
  if (thumbnails) {
    this.setupThumbnails(thumbnails);
  }
}

// Method to refresh slider positions (useful after layout changes)
refreshSliderPositions() {
  if (this.sliderItemsToShow && this.sliderItemsToShow.length > 0) {
    // Recalculate positions
    this.sliderItemOffset = this.sliderItemsToShow[1]
      ? this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft
      : this.sliderItemsToShow[0].offsetWidth;
  }
}
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.form.querySelector('[name=id]').disabled = false;
      if (!this.sticky) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';

      // Start cart monitoring for removed items
      this.startCartMonitoring();
      
      // Clean up old cache entries
      this.cleanupStockLimitsCache();
    }
    onSubmitHandler(evt) {
      evt.preventDefault();
      if (!this.form.reportValidity()) {
        return;
      }
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();

      // Get form data to extract variant info
      let formData = new FormData(this.form);
      const variantId = formData.get('id');
      const quantityToAdd = parseInt(formData.get('quantity') || '1');

      // Check both Shopify inventory limits and pre-order limits before adding to cart
      Promise.resolve(this.checkShopifyInventoryLimits(variantId, quantityToAdd))
        .then((canAddShopify) => {
          if (!canAddShopify) {
            // Stop loading state and return early
            submitButtons.forEach((submitButton) => {
              submitButton.classList.remove('loading');
              submitButton.removeAttribute('aria-disabled');
            });
            return Promise.resolve(false);
          }
          
          // If Shopify check passes, check pre-order limits
          return this.checkPreOrderLimitsBeforeAddToCart(variantId, quantityToAdd);
        })
        .then((canAdd) => {
          if (canAdd === false) {
            // Stop loading state and return early
            submitButtons.forEach((submitButton) => {
              submitButton.classList.remove('loading');
              submitButton.removeAttribute('aria-disabled');
            });
            return;
          }

          // If check passes, proceed with adding to cart
          const config = {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/javascript'
            }
          };

          formData.append('sections', this.getSectionsToRender().map((section) => section.section));
          formData.append('sections_url', window.location.pathname);
          config.body = formData;

          fetch(`${theme.routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                dispatchCustomEvent('product:variant-error', {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.description,
                  message: response.message
                });
                this.handleErrorMessage(response.description);
                return;
              }

              this.renderContents(response);

              // Update localStorage limits after successful cart addition (no API call needed)
              const addedVariantId = formData.get('id');
              const addedQuantity = parseInt(formData.get('quantity') || '1');
              let productChildrens = window.productChildrens?.variants;
              let currentVariantData = productChildrens?.find(item => item.id == addedVariantId);

              // Update localStorage directly with the data we already have
              const updateResult = this.updatePreOrderLimitsInStorage(addedVariantId, addedQuantity, currentVariantData, null);

              // Check if update failed due to limit exceeded
              if (updateResult && !updateResult.success) {
                return false;
              }

              dispatchCustomEvent('cart:item-added', {
                product: response.hasOwnProperty('items') ? response.items[0] : response
              });
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              submitButtons.forEach((submitButton) => {
                submitButton.classList.remove('loading');
                submitButton.removeAttribute('aria-disabled');
              });
            });
        })
        .catch((error) => {
          // In case of error checking limits, allow the addition
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
        });
    }

    checkShopifyInventoryLimits(variantId, quantityToAdd) {
      try {
       
        // Get variant data from DOM
        const variantSpan = document.querySelector(`.variations span[data-variant-id="${variantId}"]`);
        if (!variantSpan) return true; // Allow if no variant data found
   
        const inventoryPolicy = variantSpan.getAttribute('data-variant-preorder');
        const inventoryQuantity = parseInt(variantSpan.getAttribute('data-variant-quantity')) || 0;
        const isAvailable = variantSpan.getAttribute('data-variant-available') === 'true';
        
    
        // If inventory policy is "continue", allow overselling (no Shopify stock validation)
        if (inventoryPolicy === 'continue') {
          return true;
        }
        
        // For "deny" policy, check Shopify stock limits
        if (inventoryPolicy === 'deny' || !inventoryPolicy) {
          // Get current quantity in cart for this variant
          return fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
              // return true;
              let currentQuantityInCart = 0;
              const existingItem = cart.items.find(item => item.variant_id == variantId);
              if (existingItem) {
                currentQuantityInCart = existingItem.quantity;
              }
              
              const totalQuantityAfterAdd = currentQuantityInCart + quantityToAdd;
              
              // Check if trying to add more than available stock
              if (totalQuantityAfterAdd > inventoryQuantity) {
                const availableToAdd = Math.max(0, inventoryQuantity - currentQuantityInCart);
                this.showInventoryLimitMessage(inventoryQuantity, currentQuantityInCart, availableToAdd);
                return false;
              }
              
              // Check if variant is not available
              if (!isAvailable && currentQuantityInCart === 0) {
                this.showOutOfStockMessage();
                return false;
              }
              
              return true;
            })
            .catch(error => {
              console.error('Error checking cart for inventory limits:', error);
              return true; // Allow on error
            });
        }
        
        return true;
      } catch (error) {
        console.error('Error checking Shopify inventory limits:', error);
        return true; // Allow adding in case of error
      }
    }

    showInventoryLimitMessage(inventoryQuantity, currentQuantity, availableToAdd) {
      const message = document.createElement('div');
      const container = document.querySelector('.product-add-to-cart-container');
      

      message.className = 'inventory-limit-message pre-order-message-quantity';
      message.style.cssText = 'font-weight: bold; color: rgb(231, 76, 60); margin: 10px 0; text-transform: uppercase;';
      
      if (availableToAdd > 0) {
        message.textContent = `Only ${availableToAdd} item(s) available. You already have ${currentQuantity} in your cart.`;
      } else {
        message.textContent = `This item is out of stock. You already have the maximum quantity (${currentQuantity}) in your cart.`;
      }
      
      const existingMessage = document.querySelector('.inventory-limit-message');
      if (existingMessage) {
        existingMessage.remove();
      }
      
      container.insertBefore(message, container.firstChild);
      
      // Auto-remove message after 5 seconds
      setTimeout(() => {
        if (message.parentNode) {
          message.remove();
        }
      }, 5000);
    }

    showOutOfStockMessage() {
      const message = document.createElement('div');
      const container = document.querySelector('.product-add-to-cart-container');
      
      message.className = 'out-of-stock-message';
      message.style.cssText = 'color: #e74c3c; font-weight: bold; margin: 10px 0; padding: 10px; border-radius: 4px;';
      message.textContent = 'This item is currently out of stock.';
      
      const existingMessage = document.querySelector('.out-of-stock-message');
      if (existingMessage) {
        existingMessage.remove();
      }
      
      container.insertBefore(message, container.firstChild);
      
      // Auto-remove message after 5 seconds
      setTimeout(() => {
        if (message.parentNode) {
          message.remove();
        }
      }, 5000);
    }

    async checkPreOrderLimitsBeforeAddToCart(variantId, quantityToAdd) {
      try {
        // Get current cart to check existing quantities
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();

        // Find existing quantity of this variant in cart
        let currentQuantityInCart = 0;
        const existingItem = cart.items.find(item => item.variant_id == variantId);
        if (existingItem) {
          currentQuantityInCart = existingItem.quantity;
        }

        // Get variant IDs to check (including product children if exists)
        let productChildrens = window.productChildrens?.variants;
        let currentVariantData = productChildrens?.find(item => item.id == variantId);
        let variantIds = currentVariantData?.product_childrens;

        if (!Array.isArray(variantIds) || variantIds.length === 0) {
          variantIds = 'gid://shopify/ProductVariant/' + variantId;
        } else {
          variantIds = variantIds.map(id => `gid://shopify/ProductVariant/${id}`).join(',');
        }

        // Check cache first for better performance
        const stockLimitsCache = JSON.parse(localStorage.getItem('preOrderStockLimits') || '{}');
        const cacheKey = String(variantIds);
        const cachedLimit = stockLimitsCache[cacheKey];

        if (cachedLimit && cachedLimit.stockLimit) {
          
          const totalQuantityAfterAdd = currentQuantityInCart + quantityToAdd;

          if (totalQuantityAfterAdd > cachedLimit.stockLimit) {
            this.showPreOrderLimitMessage(cachedLimit.stockLimit, currentQuantityInCart);
            return false; // Don't allow adding to cart
          }

          // Also check localStorage limits for individual variants
          const preOrderLimits = this.getPreOrderLimitsFromStorage();
          
          // If it's a parent product, check all children
          if (currentVariantData?.product_childrens && Array.isArray(currentVariantData.product_childrens) && currentVariantData.product_childrens.length > 0) {
            for (const childId of currentVariantData.product_childrens) {
              if (preOrderLimits[childId]) {
                const newQuantity = preOrderLimits[childId].usedQuantity + quantityToAdd;
                if (newQuantity > cachedLimit.stockLimit) {
                  this.showPreOrderLimitMessage(cachedLimit.stockLimit, preOrderLimits[childId].usedQuantity);
                  return false;
                }
              } else {
                if (quantityToAdd > cachedLimit.stockLimit) {
                  this.showPreOrderLimitMessage(cachedLimit.stockLimit, 0);
                  return false;
                }
              }
            }
          } else {
            // Individual variant check
            if (preOrderLimits[variantId]) {
              const newQuantity = preOrderLimits[variantId].usedQuantity + quantityToAdd;
              if (newQuantity > cachedLimit.stockLimit) {
                this.showPreOrderLimitMessage(cachedLimit.stockLimit, preOrderLimits[variantId].usedQuantity);
                return false;
              }
            } else {
              if (quantityToAdd > cachedLimit.stockLimit) {
                this.showPreOrderLimitMessage(cachedLimit.stockLimit, 0);
                return false;
              }
            }
          }

          return true; // Allow adding to cart
        }

        return true; // Allow if no cached limit found

      } catch (error) {
        console.error('Error checking pre-order limits:', error);
        return true; // Allow adding in case of error
      }
    }

    showPreOrderLimitMessage(stockLimit, currentQuantity = 0) {
      // Calculate how many items can still be added
      const availableQuantity = Math.max(0, stockLimit - currentQuantity);
      
      // Show simple error message (red text, no border, no background)
      const message = document.createElement('div');
      const button = document.querySelector('.single-add-to-cart-button');
      const container = document.querySelector('.product-add-to-cart-container');

      message.className = 'pre-order-message-quantity';
      message.style.cssText = 'color: #e74c3c; font-weight: bold; margin: 10px 0; font-size: 12px; text-align: center;';
      
      if (availableQuantity > 0) {
        message.textContent = `YOU CAN ONLY ADD ${availableQuantity} MORE ITEM(S) TO YOUR CART!`;
      } else {
        message.textContent = `YOU ALREADY HAVE THE MAXIMUM PRE-ORDER QUANTITY IN YOUR CART!`;
      }

      const existingMessage = document.querySelector('.pre-order-message-quantity');
      if (existingMessage) {
        existingMessage.remove();
      }

      container.insertBefore(message, container.firstChild);
      button.disabled = true;

      // Auto-remove message after 10 seconds
      setTimeout(() => {
        if (message.parentNode) {
          message.remove();
          button.disabled = false;
        }
      }, 10000);
    }

    async checkLocalStorageLimits(variantId, quantityToAdd, currentVariantData, preOrderResult) {
      // Simplified version - just sync localStorage but don't block anything
      await this.syncLocalStorageWithCart();

      return { hasConflict: false };
    }

    getPreOrderLimitsFromStorage() {
      try {
        const stored = localStorage.getItem('preOrderLimits');
        return stored ? JSON.parse(stored) : {};
      } catch (error) {
        console.error('Error reading preOrderLimits from localStorage:', error);
        return {};
      }
    }

    updatePreOrderLimitsInStorage(variantId, quantityAdded, currentVariantData, preOrderResult) {
      const isParent = currentVariantData?.product_childrens && Array.isArray(currentVariantData.product_childrens) && currentVariantData.product_childrens.length > 0;
      const preOrderLimits = this.getPreOrderLimitsFromStorage();
      const parentRegistry = this.getParentRegistryFromStorage();
      
      // Get stock limits cache to use real limits
      const stockLimitsCache = JSON.parse(localStorage.getItem('preOrderStockLimits') || '{}');

      if (isParent) {
        // When adding a parent, register it and add/update quantity for all children
        const children = currentVariantData.product_childrens;
        const productHandle = window.location.pathname.split('/products/')[1]?.split('/')[0] || 'UNKNOWN_PRODUCT';

        // Get cache key for this parent
        const variantIds = children.map(id => `gid://shopify/ProductVariant/${id}`).join(',');
        const cacheKey = String(variantIds);
        const cachedLimit = stockLimitsCache[cacheKey];
        const realStockLimit = cachedLimit?.stockLimit || 999; // Default to 999 if no cache

        // Check if any child would exceed limit BEFORE making changes
        for (const childId of children) {
          if (preOrderLimits[childId]) {
            const newQuantity = preOrderLimits[childId].usedQuantity + quantityAdded;
            if (newQuantity > realStockLimit) {
              this.showPreOrderLimitMessage(realStockLimit, preOrderLimits[childId].usedQuantity);
              return { success: false, error: `Exceeds pre-order limit (${realStockLimit})` };
            }
          } else {
            if (quantityAdded > realStockLimit) {
              this.showPreOrderLimitMessage(realStockLimit, 0);
              return { success: false, error: `Exceeds pre-order limit (${realStockLimit})` };
            }
          }
        }

        // If we get here, all checks passed - proceed with updates
        // Register this parent with its children
        parentRegistry[variantId] = {
          children: children,
          productHandle: productHandle,
          addedAt: new Date().toISOString()
        };

        // Add quantities for all children with real limit
        for (const childId of children) {
          if (preOrderLimits[childId]) {
            // Add to existing quantity
            preOrderLimits[childId].usedQuantity += quantityAdded;
          } else {
            // Create new entry with real stock limit
            preOrderLimits[childId] = {
              usedQuantity: quantityAdded,
              limit: realStockLimit, // Use real stock limit from cache
              source: productHandle.toUpperCase().replace(/-/g, '_'),
              parentVariantId: variantId // Track which parent owns this
            };
          }
        }

        // Save parent registry
        try {
          localStorage.setItem('preOrderParentRegistry', JSON.stringify(parentRegistry));
        } catch (error) {
          console.error('❌ Error saving parent registry:', error);
        }

      } else {
        // Get cache key for individual variant
        const variantIds = `gid://shopify/ProductVariant/${variantId}`;
        const cacheKey = String(variantIds);
        const cachedLimit = stockLimitsCache[cacheKey];
        const realStockLimit = cachedLimit?.stockLimit || 999; // Default to 999 if no cache

        // Check if would exceed limit BEFORE making changes
        if (preOrderLimits[variantId]) {
          const newQuantity = preOrderLimits[variantId].usedQuantity + quantityAdded;
          if (newQuantity > realStockLimit) {
            this.showPreOrderLimitMessage(realStockLimit, preOrderLimits[variantId].usedQuantity);
            return { success: false, error: `Exceeds pre-order limit (${realStockLimit})` };
          }
          // If check passed, update
          preOrderLimits[variantId].usedQuantity = newQuantity;
        } else {
          if (quantityAdded > realStockLimit) {
            this.showPreOrderLimitMessage(realStockLimit, 0);
            return { success: false, error: `Exceeds pre-order limit (${realStockLimit})` };
          }
          // If check passed, create
          preOrderLimits[variantId] = {
            usedQuantity: quantityAdded,
            limit: realStockLimit, // Use real stock limit from cache
            source: 'INDIVIDUAL'
          };
        }
      }

      // Save updated limits to localStorage
      try {
        localStorage.setItem('preOrderLimits', JSON.stringify(preOrderLimits));
      } catch (error) {
        console.error('❌ Error saving preOrderLimits to localStorage:', error);
      }

      return { success: true };
    }

    clearPreOrderLimitsFromStorage() {
      try {
        localStorage.removeItem('preOrderLimits');
      } catch (error) {
        console.error('Error clearing preOrderLimits from localStorage:', error);
      }
    }

    cleanupStockLimitsCache() {
      try {
        const stockLimitsCache = JSON.parse(localStorage.getItem('preOrderStockLimits') || '{}');
        const currentTime = new Date();
        const maxAgeHours = 2; // Cache válido por 2 horas
        
        let hasChanges = false;
        
        for (const [key, data] of Object.entries(stockLimitsCache)) {
          if (data.cachedAt) {
            const cachedTime = new Date(data.cachedAt);
            const ageInHours = (currentTime - cachedTime) / (1000 * 60 * 60);
            
            if (ageInHours > maxAgeHours) {
              delete stockLimitsCache[key];
              hasChanges = true;
            }
          }
        }
        
        if (hasChanges) {
          localStorage.setItem('preOrderStockLimits', JSON.stringify(stockLimitsCache));
        }
        
      } catch (error) {
        console.error('❌ Error cleaning stock limits cache:', error);
      }
    }

    getParentRegistryFromStorage() {
      try {
        const stored = localStorage.getItem('preOrderParentRegistry');
        return stored ? JSON.parse(stored) : {};
      } catch (error) {
        console.error('Error reading parent registry from localStorage:', error);
        return {};
      }
    }

    // Helper function to sync localStorage with actual cart (call this when cart changes externally)
    async syncLocalStorageWithCart() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        if (!cart.items || cart.items.length === 0) {
          // Cart is empty, clear localStorage
          this.clearPreOrderLimitsFromStorage();
          return;
        }

        // Get current localStorage limits
        const preOrderLimits = this.getPreOrderLimitsFromStorage();
        const productChildrens = window.productChildrens?.variants || [];

        // Check if any localStorage entries correspond to items NOT in the cart
        const cartVariantIds = cart.items.map(item => String(item.variant_id));

        let shouldClearStorage = false;

        // For each limit in localStorage, check if the corresponding parent is still in cart
        for (const [limitVariantId, limitData] of Object.entries(preOrderLimits)) {
          if (limitData.source === 'INDIVIDUAL') {
            if (!cartVariantIds.includes(String(limitVariantId))) {
              shouldClearStorage = true;
              break;
            }
          } else {
            // Parent limit - find the parent product and check if it's in cart
            const parentProduct = productChildrens.find(variant =>
              variant.product_childrens &&
              variant.product_childrens.includes(parseInt(limitVariantId))
            );

            if (parentProduct && !cartVariantIds.includes(String(parentProduct.id))) {
              shouldClearStorage = true;
              break;
            }
          }
        }

        if (shouldClearStorage) {
          this.clearPreOrderLimitsFromStorage();
        }

      } catch (error) {
        console.error('❌ Error syncing preOrderLimits with cart:', error);
      }
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));



      let product_drawer = document.getElementById('Product-Drawer');
      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.querySelector('.product-quick-images--container').classList.remove('active');
        document.body.classList.remove('open-quick-view');

        if (window.innerWidth < 1069) {
          product_drawer.classList.remove('active');
          if (document.getElementById('Cart-Drawer')) {
            document.getElementById('Cart-Drawer').classList.add('active');
            document.body.classList.add('open-cart');
            document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
            dispatchCustomEvent('cart-drawer:open');
          }
        } else {
          product_drawer.querySelector('.product-quick-images--container').addEventListener('transitionend', function () {
            product_drawer.classList.remove('active');

            if (document.getElementById('Cart-Drawer')) {
              document.getElementById('Cart-Drawer').classList.add('active');
              document.body.classList.add('open-cart');
              document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
              dispatchCustomEvent('cart-drawer:open');
            }
          });
        }

        if (!document.getElementById('Cart-Drawer')) {
          document.body.classList.remove('open-cc');
        }
      } else if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.body.classList.add('open-cart');
        document.getElementById('Cart-Drawer').classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    // Cart monitoring for removed items
    startCartMonitoring() {
      // Store initial cart state
      this.previousCartState = null;

      // Monitor cart changes via periodic checking
      this.cartMonitorInterval = setInterval(() => {
        this.checkForRemovedItems();
      }, 2000); // Check every 2 seconds

      // Also monitor on page visibility change (when user comes back to tab)
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) {
          this.checkForRemovedItems();
        }
      });
    }

    async checkForRemovedItems() {
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart.js');
        const currentCart = await response.json();

        // If the cart is empty, clear pre-order related localStorage immediately
        if (!currentCart.items || currentCart.items.length === 0) {
          this.clearPreOrderLimitsFromStorage();
          // Reset previousCartState to reflect empty cart
          this.previousCartState = [];
          return;
        }

        if (this.previousCartState === null) {
          // First time - just store the state
          this.previousCartState = currentCart.items.map(item => ({
            variant_id: item.variant_id,
            quantity: item.quantity
          }));
          return;
        }

        const currentItems = currentCart.items.map(item => ({
          variant_id: item.variant_id,
          quantity: item.quantity
        }));

        // Check for removed or reduced items
        for (const previousItem of this.previousCartState) {
          const currentItem = currentItems.find(item => item.variant_id === previousItem.variant_id);

          if (!currentItem) {
            // Item completely removed
            this.handleRemovedItem(previousItem.variant_id, previousItem.quantity);
          } else if (currentItem.quantity < previousItem.quantity) {
            // Item quantity reduced
            const reducedBy = previousItem.quantity - currentItem.quantity;
            this.handleRemovedItem(previousItem.variant_id, reducedBy);
          }
        }

        // Update previous state
        this.previousCartState = currentItems;

      } catch (error) {
        console.error('❌ Error checking for removed items:', error);
      }
    }

    handleRemovedItem(removedVariantId, removedQuantity) {

      const parentRegistry = this.getParentRegistryFromStorage();
      const preOrderLimits = this.getPreOrderLimitsFromStorage();

      // Check if the removed item is a parent product
      if (parentRegistry[removedVariantId]) {
        const parentInfo = parentRegistry[removedVariantId];

        // Reduce quantities for all children of this parent
        for (const childId of parentInfo.children) {
          if (preOrderLimits[childId]) {
            const newQuantity = Math.max(0, preOrderLimits[childId].usedQuantity - removedQuantity);

            // Keep the entry but zero the quantity instead of deleting
            preOrderLimits[childId].usedQuantity = newQuantity;
          }
        }

        // If completely removed, clean up parent registry
        if (removedQuantity >= (this.previousCartState.find(item => item.variant_id === removedVariantId)?.quantity || 0)) {
          delete parentRegistry[removedVariantId];

          try {
            localStorage.setItem('preOrderParentRegistry', JSON.stringify(parentRegistry));
          } catch (error) {
            console.error('❌ Error updating parent registry:', error);
          }
        }

      } else {
        // Check if removed item is an individual child
        if (preOrderLimits[removedVariantId]) {
          const newQuantity = Math.max(0, preOrderLimits[removedVariantId].usedQuantity - removedQuantity);
          preOrderLimits[removedVariantId].usedQuantity = newQuantity;
        }
      }

      // Save updated limits
      try {
        localStorage.setItem('preOrderLimits', JSON.stringify(preOrderLimits));
      } catch (error) {
        console.error('❌ Error saving updated limits:', error);
      }
    }
  });
}



if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}

document.addEventListener("mouseenter", function (event) {
    if (event.target instanceof HTMLElement && event.target.closest(".badge_popup")) {
        const popup = document.querySelector(".black_friday_popup");
        if (popup) popup.style.display = "block";
    }
}, true);

document.addEventListener("mouseleave", function (event) {
    if (event.target instanceof HTMLElement && event.target.closest(".badge_popup")) {
        const popup = document.querySelector(".black_friday_popup");
        if (popup) popup.style.display = "none";
    }
}, true);
// Monitor quantity-selector changes
document.addEventListener('change', function (e) {
  if (e.target.closest('quantity-selector')) {
    const input = e.target;

    // Skip if this is a programmatic change to avoid loops
    if (input.dataset.programmaticChange === 'true') {
      input.dataset.programmaticChange = 'false';
      return;
    }

    const productId = input.dataset.productId || 'N/A';
    const variantId = input.dataset.variantId || 'N/A';
    let productChildrens = window.productChildrens?.variants;
    let variantIds = productChildrens?.find(item => item.id == variantId)?.product_childrens;
    if (!Array.isArray(variantIds) || variantIds.length === 0) {
      variantIds = 'gid://shopify/ProductVariant/' + variantId;
    } else {
      variantIds = variantIds.map(id => `gid://shopify/ProductVariant/${id}`).join(',');
    }

    const url = `https://lionfish-app-zikm2.ondigitalocean.app/api/get-product?variantIds=${variantIds}&variantId=gid://shopify/ProductVariant/${variantId}`;

    // Check current cart quantity asynchronously
    Promise.all([
      fetch(url).then(res => res.json()),
      fetch('/cart.js').then(res => res.json())
    ]).then(([preOrderData, cart]) => {
      console.clear()
      console.log(preOrderData, cart)
      // Extract product handle from current page URL
      const productHandle = window.location.pathname.split('/products/')[1]?.split('/')[0] || null;

      const productParent = preOrderData?.productParent;

      if (productParent && preOrderData?.result) {
        preOrderData.result = preOrderData.result.map(item => ({
          ...item,
          parentProduct: productParent
        }));
      }

      // Find the item with the earliest ETA date
      let data = findEarliestValidContainerItem(preOrderData?.result, variantIds, productHandle);
      if (!data?.stockCalc) return;

      // Find existing quantity in cart
      let currentQuantityInCart = 0;
      const existingItem = cart.items.find(item => item.variant_id == variantId);
      if (existingItem) {
        currentQuantityInCart = existingItem.quantity;
      }

      const requestedQuantity = parseInt(input.value);
      const totalQuantityWithCurrent = currentQuantityInCart + requestedQuantity;

      if (totalQuantityWithCurrent > data.stockCalc) {
        // Calculate available quantity
        const availableQuantity = Math.max(0, data.stockCalc - currentQuantityInCart);
        
        // Show simple error message (red text, no border, no background)
        const message = document.createElement('div');
        const button = document.querySelector('.single-add-to-cart-button');
        const container = document.querySelector('.product-add-to-cart-container');
        message.className = 'pre-order-message-quantity';
        message.style.cssText = 'color: #e74c3c; font-weight: bold; margin: 10px 0; font-size: 12px; text-align: center;';
        
        if (availableQuantity > 0) {
          message.textContent = `YOU CAN ONLY ADD ${availableQuantity} MORE ITEM(S) TO YOUR CART!`;
        } else {
          message.textContent = `YOU ALREADY HAVE THE MAXIMUM PRE-ORDER QUANTITY IN YOUR CART!`;
        }

        //adicionar se a mensagem não existir
        if (!document.querySelector('.pre-order-message-quantity')) {
          container.insertBefore(message, container.firstChild);
        }
        button.disabled = true;
        input.disabled = true;

        // Auto-remove message after 10 seconds
        setTimeout(() => {
          if (message.parentNode) {
            message.remove();
            button.disabled = false;
            input.disabled = false;
          }
        }, 10000);

      } else {
        // Only enable controls if quantity is valid
        input.disabled = false;
        const existingMessage = document.querySelector('.pre-order-message-quantity');
        if (existingMessage) {
          existingMessage.remove();
        }
        const button = document.querySelector('.single-add-to-cart-button');
        if (button) {
          button.disabled = false;
        }
      }
    }).catch(err => console.error('Err:', err));
  }
});

// Global function to remove pre-order message
function removePreOrderMessage() {
  const existingMessage = document.querySelector('.pre-order-message-quantity');
  const existingMessage2 = document.querySelector('.preorder-message');
  if (existingMessage) {
    existingMessage.remove();
  }
  if (existingMessage2) {
    existingMessage2.remove();
  }
}

// Global function to find the item with the earliest ETA date from valid containers
function findEarliestValidContainerItem(items, variantIds = null, productHandle = null) {
  if (!Array.isArray(items) || items.length === 0) return null;
  const currentDate = new Date();

  // Get the number of children from productChildrens to validate container completeness
  const getChildrenCount = (variantIds) => {
    if (typeof variantIds === 'string' && variantIds.includes(',')) {
      return variantIds.split(',').length;
    }
    return 1; // Single variant case
  };

  const containerGroups = items.reduce((groups, item) => {

    // On page load (and when returning from bfcache), clear pre-order localStorage
    // when the cart is empty. This prevents stale preOrderLimits entries from
    // lingering when the user navigates or selects variants without having items
    // in the cart.
    function clearPreOrderStorageIfCartEmpty() {
      try {
        const cartUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'cart.js' : '/cart.js';
        fetch(cartUrl)
          .then(res => res.json())
          .then(cart => {
            if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) {
              try {
                localStorage.removeItem('preOrderLimits');
                localStorage.removeItem('preOrderParentRegistry');
                console && console.info && console.info('[preOrder] cleared preOrderLimits & parent registry because cart is empty');
              } catch (e) {
                console && console.error && console.error('[preOrder] error clearing localStorage', e);
              }
            }
          })
          .catch(err => {
            // Non-fatal: if we can't fetch cart, do nothing
            console && console.debug && console.debug('[preOrder] could not check cart for emptiness', err);
          });
      } catch (error) {
        console && console.debug && console.debug('[preOrder] clearPreOrderStorageIfCartEmpty error', error);
      }
    }

    // Run on initial load
    document.addEventListener('DOMContentLoaded', clearPreOrderStorageIfCartEmpty);
    // Also run when the page is shown again (bfcache/back navigation)
    window.addEventListener('pageshow', function (event) {
    // always check; if event.persisted is true it's the bfcache case
    clearPreOrderStorageIfCartEmpty();
  });
    const containerId = item.containerId;
    if (!groups[containerId]) {
      groups[containerId] = [];
    }
    groups[containerId].push(item);
    return groups;
  }, {});

  const validItems = [];

  for (const [containerId, containerItems] of Object.entries(containerGroups)) {
    if (variantIds) {
      const isGotoProduct =
        productHandle &&
        (productHandle === 'goto-sofa-three-seater' ||
          productHandle === 'goto-sofa-loveseat');

      if (!isGotoProduct) {
        const expectedChildrenCount = getChildrenCount(variantIds);
        if (containerItems.length !== expectedChildrenCount) {
          continue;
        }
      }
    }

    const allItemsValid = containerItems.every(item => {
      if (!item || !item.product || !item.product.container || !item.product.container.ETA) return false;
      if (item.product.container.inUse == false) return false;
      if (item.product.container.statusLocked === true) return false;
      // Validar se a data ETA é maior que a data atual
      const etaDate = new Date(item.product.container.ETA);
      if (etaDate <= currentDate) return false;

      if (item.product.container.startDate) {
        const startDate = new Date(item.product.container.startDate);
        if (startDate > currentDate) return false;
      }
      if (item.product.container.endDate) {
        const endDate = new Date(item.product.container.endDate);
        if (endDate < currentDate) return false;
      }
      if (item.parentProduct) {
        const { stockManagement, inventoryQuantity } = item.parentProduct;
        if (stockManagement === "outOfStock" && inventoryQuantity > 0) {
          return false;
        }
        if (stockManagement === "forceInStock") {
          return false;
        }
      }

      const stock = typeof item.stockCalc === 'number' ? item.stockCalc : 0;
      return stock >= 1;
    });

    if (allItemsValid) {
      // Adicionar todos os itens válidos do container, não apenas o mais antigo
      validItems.push(...containerItems);
    }
  }
  
  if (validItems.length === 0) return null;
  // Encontrar o item com ETA mais antigo entre todos os itens válidos
  const earliestItem = validItems.reduce((earliest, item) => {
    const itemDate = new Date(item.product.container.ETA);
    const earliestDate = new Date(earliest.product.container.ETA);
    if (itemDate < earliestDate) {
      return item;
    } else if (itemDate.getTime() === earliestDate.getTime()) {
      const itemStock = typeof item.stockCalc === 'number' ? item.stockCalc : Infinity;
      const earliestStock = typeof earliest.stockCalc === 'number' ? earliest.stockCalc : Infinity;
      return itemStock < earliestStock ? item : earliest;
    } else {
      return earliest;
    }
  });

  // Register stock limits in localStorage for performance
  if (earliestItem && typeof earliestItem.stockCalc === 'number') {
    try {
      const stockLimitsCache = JSON.parse(localStorage.getItem('preOrderStockLimits') || '{}');
      
      // Create a cache key based on variant IDs
      const cacheKey = Array.isArray(variantIds) ? variantIds.join(',') : String(variantIds);
      
      stockLimitsCache[cacheKey] = {
        stockLimit: earliestItem.stockCalc,
        productHandle: productHandle,
        containerId: earliestItem.containerId,
        ETA: earliestItem.product.container.ETA,
        cachedAt: new Date().toISOString()
      };
      
      setTimeout(() => {
        localStorage.setItem('preOrderStockLimits', JSON.stringify(stockLimitsCache));
      }, 1000);
      
    } catch (error) {
      console.error('❌ Error caching stock limits:', error);
    }
  }

  return earliestItem;
}
window.addEventListener('load', function() {
  // Seleciona o botão dentro da div com a classe "single-add-to-cart-button"
  const addToCartBtn = document.querySelector('.single-add-to-cart-button');
  
  if (addToCartBtn) {
    // Remove o atributo style (caso exista)
    addToCartBtn.removeAttribute('style');
    console.log('Estilos inline do botão foram removidos com sucesso.');
  } else {
    console.warn('Botão dentro de .single-add-to-cart-button não encontrado.');
  }
});

/**
 * Rove Sticky Add to Cart Component
 */
if (!customElements.get('rove-sticky-add-to-cart')) {
  class RoveStickyAddToCart extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.section;
      this.originalAddToCartButton = null;
      this.intersectionObserver = null;
      this.isVisible = false;
    }

    connectedCallback() {
      // Ensure component starts hidden
      this.style.display = 'none';
      this.classList.remove('rove-sticky--visible');
      this.isVisible = false;
      
      // Wait for page to be fully loaded before setting up
      if (document.readyState === 'complete') {
        this.initializeComponent();
      } else {
        window.addEventListener('load', () => {
          this.initializeComponent();
        });
      }
      
      this.setupVariantChangeListener();
    }

    initializeComponent() {
      // Try multiple approaches to find the button
      this.findAddToCartButton();
      
      // Set up Rebuy cart integration
      this.setupRebuyCart();
      
      // Set up initial color swatch
      this.setupInitialColorSwatch();
      
      // Listen for window resize to recalculate chat button position
      window.addEventListener('resize', () => {
        if (this.isVisible) {
          this.adjustChatButton();
        }
      });
    }

    setupInitialColorSwatch() {
      // Wait a bit for the swatches to be fully rendered
      setTimeout(() => {
        this.attemptInitialColorSwatchSetup();
      }, 100);

      // Also try again after a longer delay to ensure everything is loaded
      setTimeout(() => {
        this.attemptInitialColorSwatchSetup();
      }, 500);
    }

    attemptInitialColorSwatchSetup() {
      // Get the current variant from the main product
      const mainProductForm = document.querySelector(`#product-form-${this.sectionId}`);
      if (mainProductForm) {
        const variantId = mainProductForm.querySelector('input[name="id"]').value;
        const currentVariant = window.productData?.variants?.find(v => v.id == variantId);
        
        if (currentVariant) {
          this.updateColorSwatch(currentVariant);
        } else {
          const activeSwatch = this.findActiveSwatch();
          if (activeSwatch) {
            this.updateColorSwatchFromActiveSwatch(activeSwatch);
          }
        }
      }

      // Update badges positioning on initial setup
      this.updateBadgesPosition();
    }

    updateColorSwatchFromActiveSwatch(activeSwatch) {
      const colorSwatch = this.querySelector('.color-swatch');
      if (!colorSwatch || !activeSwatch) return;

      const computedStyle = window.getComputedStyle(activeSwatch);
      const backgroundImage = computedStyle.getPropertyValue('background-image');
      const backgroundColor = computedStyle.getPropertyValue('background-color');
      
      if (backgroundImage && backgroundImage !== 'none' && backgroundImage !== 'url()') {
        const imageUrl = backgroundImage.replace(/url\(['"]?([^'"]*)['"]?\)/, '$1');
        colorSwatch.innerHTML = `<img src="${imageUrl}" alt="Color swatch" style="width: 100%; height: 100%; object-fit: cover; border-radius: 50%;">`;
      } else if (backgroundColor && backgroundColor !== 'rgba(0, 0, 0, 0)' && backgroundColor !== 'transparent') {
        colorSwatch.style.backgroundColor = backgroundColor;
        colorSwatch.innerHTML = '';
      } else {
        const colorImage = computedStyle.getPropertyValue('--option-color-image');
        const colorValue = computedStyle.getPropertyValue('--option-color');
        
        if (colorImage && colorImage !== 'none') {
          const cleanImageUrl = colorImage.replace(/url\(['"]?([^'"]*)['"]?\)/, '$1');
          colorSwatch.innerHTML = `<img src="${cleanImageUrl}" alt="Color swatch" style="width: 100%; height: 100%; object-fit: cover; border-radius: 50%;">`;
        } else if (colorValue && colorValue !== 'none') {
          colorSwatch.style.backgroundColor = colorValue;
          colorSwatch.innerHTML = '';
        } else {
          const fallbackColor = 'espresso';
          colorSwatch.style.backgroundColor = fallbackColor;
          colorSwatch.innerHTML = '';
        }
      }
    }

    setupRebuyCart() {
      // Wait for Rebuy to be available
      const checkRebuy = () => {
        if (window.Rebuy && window.Rebuy.Cart) {
          this.setupRebuyFormHandler();
        } else {
          setTimeout(checkRebuy, 100);
        }
      };
      checkRebuy();
    }

    setupRebuyFormHandler() {
      const form = this.querySelector('form');
      if (form) {
        form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.handleRebuyAddToCart();
        });
      }
    }

    handleRebuyAddToCart() {
      const form = this.querySelector('form');
      if (!form || !window.Rebuy || !window.Rebuy.Cart) {
        form.submit();
        return;
      }

      const formData = new FormData(form);
      const variantId = formData.get('id');
      
      if (!variantId) {
        return;
      }

      const data = {
        id: parseInt(variantId),
        quantity: 1
      };

      const options = {
        onSuccess: (response) => {
          document.dispatchEvent(new CustomEvent('cart:updated'));
        },
        onError: (error) => {
          form.submit();
        }
      };

      window.Rebuy.Cart.addItem(data, options);
    }

    disconnectedCallback() {
      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
      }
      if (this.mutationObserver) {
        this.mutationObserver.disconnect();
      }
    }

    findAddToCartButton() {
      this.originalAddToCartButton = document.querySelector(`#AddToCart`);
      
      if (this.originalAddToCartButton) {
        this.setupIntersectionObserver();
        return;
      }

      const selectors = [
        '#AddToCart',
        'button[id*="AddToCart"]',
        'button[class*="add-to-cart"]',
        '.single-add-to-cart-button',
        'button[name="add"]'
      ];

      for (const selector of selectors) {
        this.originalAddToCartButton = document.querySelector(selector);
        if (this.originalAddToCartButton) {
          this.setupIntersectionObserver();
          return;
        }
      }

      this.showSticky();
    }

    setupIntersectionObserver() {
      if (!this.originalAddToCartButton) return;

      this.intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          
          if (entry.target === this.originalAddToCartButton) {
            // Only show sticky if the button is completely above the viewport (user scrolled past it)
            // Don't show if the button is below the viewport (user hasn't reached it yet)
            if (entry.intersectionRatio === 0 && entry.boundingClientRect.bottom < 0) {
              this.showSticky();
            } else {
              this.hideSticky();
            }
          }
        });
      }, {
        threshold: 0,
        rootMargin: '0px'
      });

      this.intersectionObserver.observe(this.originalAddToCartButton);
      
      setTimeout(() => {
        this.checkInitialVisibility();
      }, 100);
    }

    checkInitialVisibility() {
      if (this.originalAddToCartButton) {
        const rect = this.originalAddToCartButton.getBoundingClientRect();
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;
        const windowWidth = window.innerWidth || document.documentElement.clientWidth;
        
        const isVisible = rect.top >= 0 && rect.left >= 0 && 
                         rect.bottom <= windowHeight && 
                         rect.right <= windowWidth;
        
        if (!isVisible) {
          this.showSticky();
        } else {
          this.hideSticky();
        }
      }
    }

    setupVariantChangeListener() {
      // Listen for variant changes to update color and price
      document.addEventListener('product:variant-change', (event) => {
        if (event.detail.sectionId === this.sectionId) {
          this.updateVariantInfo(event.detail.variant);
        }
      });
    }

    updateVariantInfo(variant) {
      if (!variant) return;

      // Update color name
      const colorNameElement = this.querySelector('#sticky-selected-color');
      if (colorNameElement && variant.option1) {
        colorNameElement.textContent = variant.option1;
      }

      // Update color swatch with proper color/image
      this.updateColorSwatch(variant);

      // Update price - use the same price rendering as the main product
      const priceElement = this.querySelector(`#sticky-price-${this.sectionId}`);
      if (priceElement) {
        // Get the price from the main product price element to maintain consistency
        const mainPriceElement = document.querySelector(`#price-${this.sectionId}`);
        if (mainPriceElement) {
          priceElement.innerHTML = mainPriceElement.innerHTML;
        } else {
          // Fallback to manual price formatting
          const price = new Intl.NumberFormat('en-CA', {
            style: 'currency',
            currency: 'CAD'
          }).format(variant.price / 100);
          
          priceElement.innerHTML = `<span class="price">${price}</span>`;
        }
      }

      // Update button state
      const button = this.querySelector('#StickyAddToCart');
      if (button) {
        if (variant.available) {
          button.disabled = false;
          button.classList.remove('sold-out');
          button.querySelector('.single-add-to-cart-button--text').textContent = 'ADD TO CART';
        } else {
          button.disabled = true;
          button.classList.add('sold-out');
          button.querySelector('.single-add-to-cart-button--text').textContent = 'SOLD OUT';
        }
      }

      // Update hidden input with new variant ID
      const hiddenInput = this.querySelector('input[name="id"]');
      if (hiddenInput) {
        hiddenInput.value = variant.id;
      }

      // Update badges positioning based on color text width
      this.updateBadgesPosition();
    }

    updateColorSwatch(variant) {
      const colorSwatch = this.querySelector('.color-swatch');
      if (!colorSwatch || !variant.option1) return;


      // Find the currently active/selected swatch in the main product
      const activeSwatch = this.findActiveSwatch();
      
      if (activeSwatch) {
        const computedStyle = window.getComputedStyle(activeSwatch);
        const backgroundImage = computedStyle.getPropertyValue('background-image');
        const backgroundColor = computedStyle.getPropertyValue('background-color');
        
        if (backgroundImage && backgroundImage !== 'none' && backgroundImage !== 'url()') {
          const imageUrl = backgroundImage.replace(/url\(['"]?([^'"]*)['"]?\)/, '$1');
          colorSwatch.innerHTML = `<img src="${imageUrl}" alt="${variant.option1}" style="width: 100%; height: 100%; object-fit: cover; border-radius: 50%;">`;
        } else if (backgroundColor && backgroundColor !== 'rgba(0, 0, 0, 0)' && backgroundColor !== 'transparent') {
          colorSwatch.style.backgroundColor = backgroundColor;
          colorSwatch.innerHTML = '';
        } else {
          const colorImage = computedStyle.getPropertyValue('--option-color-image');
          const colorValue = computedStyle.getPropertyValue('--option-color');
          
          if (colorImage && colorImage !== 'none') {
            const cleanImageUrl = colorImage.replace(/url\(['"]?([^'"]*)['"]?\)/, '$1');
            colorSwatch.innerHTML = `<img src="${cleanImageUrl}" alt="${variant.option1}" style="width: 100%; height: 100%; object-fit: cover; border-radius: 50%;">`;
          } else if (colorValue && colorValue !== 'none') {
            colorSwatch.style.backgroundColor = colorValue;
            colorSwatch.innerHTML = '';
          } else {
            const fallbackColor = variant.option1.toLowerCase().replace(/\s+/g, '-');
            colorSwatch.style.backgroundColor = fallbackColor;
            colorSwatch.innerHTML = '';
          }
        }
      } else {
        const colorValue = variant.option1.toLowerCase().replace(/\s+/g, '-');
        colorSwatch.style.backgroundColor = colorValue;
        colorSwatch.innerHTML = '';
      }

      colorSwatch.setAttribute('data-color', variant.option1);
    }

    findActiveSwatch() {
      // Look for the currently selected/active swatch in the main product
      let activeSwatch = null;

      // Method 1: Look for checked radio button and find its corresponding label
      const checkedRadio = document.querySelector('input[type="radio"][name="Color"]:checked');
      if (checkedRadio) {
        const label = document.querySelector(`label[for="${checkedRadio.id}"]`);
        if (label) {
          activeSwatch = label;
        }
      }

      if (!activeSwatch) {
        const activeElements = document.querySelectorAll('.product-option label.active, .product-option label.selected, .product-option .active label, .product-option .selected label');
        if (activeElements.length > 0) {
          activeSwatch = activeElements[0];
        }
      }

      if (!activeSwatch) {
        const currentVariantId = document.querySelector('input[name="id"]')?.value;
        if (currentVariantId) {
          const swatchLabels = document.querySelectorAll('.product-option label[data-variant-id]');
          swatchLabels.forEach(label => {
            const variantId = label.getAttribute('data-variant-id');
            if (variantId && parseInt(variantId) === parseInt(currentVariantId)) {
              activeSwatch = label;
            }
          });
        }
      }

      if (!activeSwatch) {
        const swatchLabels = document.querySelectorAll('.product-option label');
        if (swatchLabels.length > 0) {
          activeSwatch = swatchLabels[0];
        }
      }

      return activeSwatch;
    }

    updateBadgesPosition() {
      // Use requestAnimationFrame to ensure the DOM is fully updated
      requestAnimationFrame(() => {
        // Add a small delay to ensure the element is fully rendered
        setTimeout(() => {
          this.attemptBadgesPositionUpdate();
        }, 10);
      });
    }

    attemptBadgesPositionUpdate() {
      const colorTextElement = this.querySelector('#sticky-selected-color');
      const badgesElement = this.querySelector('.rove-sticky-add-to-cart--price .badges');
      
      if (colorTextElement && badgesElement) {
        // Get the width of the color text
        const colorTextWidth = colorTextElement.getBoundingClientRect().width;
        const badgesWidth = badgesElement.getBoundingClientRect().width;
        const isMobile = window.innerWidth < 768;
        
        if (isMobile) {
          badgesElement.style.display = 'none !important';
        } else {
          badgesElement.style.display = 'block !important';
        }
        
        if (colorTextWidth > 0) {
          badgesElement.style.left = `${colorTextWidth + badgesWidth}px`;
        } else {
          setTimeout(() => {
            this.attemptBadgesPositionUpdate();
          }, 100);
        }
      }
    }

    showSticky() {
      if (!this.isVisible) {
        this.style.display = 'block';
        this.offsetHeight;
        this.classList.add('rove-sticky--visible');
        this.isVisible = true;
        this.adjustChatButton();
      }
    }

    hideSticky() {
      if (this.isVisible) {
        this.classList.remove('rove-sticky--visible');
        this.isVisible = false;
        
        // Reset chat button iframe position
        this.resetChatButton();
        
        // Hide after transition
        setTimeout(() => {
          if (!this.isVisible) {
            this.style.display = 'none';
          }
        }, 300);
      }
    }

    adjustChatButton() {
      const chatButton = document.querySelector('iframe#chat-button');
      if (chatButton) {
        const stickyHeight = this.getBoundingClientRect().height;
        const bottomDistance = Math.max(stickyHeight + 24, 64);
        chatButton.style.setProperty('bottom', `${bottomDistance}px`, 'important');
      }
    }

    resetChatButton() {
      const chatButton = document.querySelector('iframe#chat-button');
      if (chatButton) {
        chatButton.style.setProperty('bottom', '', 'important');
      }
    }
  }

  customElements.define('rove-sticky-add-to-cart', RoveStickyAddToCart);
}